import React, { Component, Fragment } from "react";
import { ToastContainer, toast } from "react-toastify";
import $ from "jquery";
import Httpconfig from "../helpers/HttpconfigRetailer";
import OrderBatchRows from "./OrderBatchRows";
import {
  allocateFEFO,
  sortBatchesByExpiry,
  resolveSuggestedAllocations,
  isExpiredBatch,
  toQuantity,
  unsellableReason,
} from "../../helpers/batchAllocation";
import Constant from "../../constants";
import { MDBDataTable } from "mdbreact";
import { Link } from "react-router-dom";
import RetailerCss from "../../public/css/retailer/retailer_style.css";
import RetailerHeader from "../retailer/RetailerHeader";
import RetailerSideMenu from "../retailer/RetailerSideMenu";
import Footer from "../patient/Patientfooter";
import { reactLocalStorage } from "reactjs-localstorage";
import dateformatter from "../helpers/dateformatter";
import * as SecureLS from "secure-ls";
import DateRangeFilter from "../common/DateRangeFilter";
var ls = new SecureLS({
  encodingType: "aes",
  encryptionSecret: "medleymed",
});
const moment = require("moment");

export default class Viewretailers extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentHome: "nav-item nav-link active",
      prescriptionHome: "nav-item nav-link",
      shippedHome: "nav-item nav-link",
      deliverHome: "nav-item nav-link",
      cancelHome: "nav-item nav-link",
      processedHome: "nav-item nav-link",
      currentHomePanel: "tab-pane fade show active",
      prescriptionHomePanel: "tab-pane fade",
      processedHomePanel: "tab-pane fade",
      shippedHomePanel: "tab-pane fade",
      deliverHomePanel: "tab-pane fade",
      cancelHomePanel: "tab-pane fade",
      showOrderDetailsProcess: " pharmacy-tab collapse-hide",
      showOrdersGrid: "row showorder-list collapse-show",
      showRejectReasons: "collapse-hide",
      ordereditems: "",
      startDate: "",
      endDate: "",
      retailerRejectList: "",
      orderId: "",
      invoiceDiv: "collapse-hide",
      invoicePDFPreview: "collapse-hide",
      retailerOrderMedicineInvoiceDetailsView: "",
      totalpaid: "",
      totalPaidAmt: "",
      orderRejectReason: "",
      customerAddressId: "",
      patientAddressId: "",
      invoiceBtn: true,
      invoiceRows: [],
      retailerDetails: [],
      couponDiscountAmount: "",
      isLoading: false,
      subTotal: "0.00",
      totaldiscount: "0.00",
      totalCoupanAmt: "0.00",
      deliveryCharges: "",
      finalorderarray: [],
      retailerFinalOrderMedicineDetailsView: [],
      //  Per-document prescription view from the API, so a re-upload request
      //  can name the prescription the customer has to replace instead of
      //  asking for "a prescription" and leaving them to guess.
      orderPrescriptions: [],
      requiresPrescription: false,
      orderLevelReuploadPending: false,
      reuploadModal: "collapse-hide",
      reuploadTarget: null,
      reuploadReason: "",
      reuploadOtherReason: "",
    };

    this.getTemplateRow = this.getTemplateRow.bind(this);
    this.caliculateInvoiceAmountsNewRows =
      this.caliculateInvoiceAmountsNewRows.bind(this);
    this.clearFilters = this.clearFilters.bind(this);
  }
  // reload page
  clearFilters = () => {
    window.location.reload(); // full page reload
  }
  // To get detais after first render
  componentDidMount = () => {
    // window.addEventListener("popstate", function (e) {
    //   window.location.reload();
    // });
    let userData = ls.get("retuserObj");
    if (userData) {
      if (userData != "") {
        this.setState({
          retailerId: userData.retailer_id,
          retailerCurrency: userData.currency,
        });
        this.getRetailerDetails(userData.retailer_id);
      }
    } else {
      window.location.href = "/retailer/login";
    }

    var pdfgenerate = 0;
    pdfgenerate = localStorage.getItem("pdfgenerate");
    if (pdfgenerate == 1) {
      this.setState({
        currentHome: "nav-item nav-link",
        prescriptionHome: "nav-item nav-link",
        processedHome: "nav-item nav-link active",
        shippedHome: "nav-item nav-link",
        deliverHome: "nav-item nav-link",
        cancelHome: "nav-item nav-link",
        currentHomePanel: "tab-pane fade",
        prescriptionHomePanel: "tab-pane fade",
        processedHomePanel: "tab-pane fade show active",
        shippedHomePanel: "tab-pane fade",
        deliverHomePanel: "tab-pane fade",
        cancelHomePanel: "tab-pane fade",
        showOrderDetailsProcess: "pharmacy-tab collapse-hide",
        showRejectReasons: "collapse-hide",
        showOrdersGrid: "row showorder-list collapse-show",
        invoiceDiv: "collapse-hide",
      });
      $("#prescription_home").removeClass("collapse-show").addClass("collapse-hide");
      localStorage.removeItem("pdfgenerate");
      this.retailerOrderDetails(userData.retailer_id, 3);
    } else {
      this.retailerOrderDetails(userData.retailer_id, 1);
    }
  };
  // called after the React component props or state has changed.

  componentDidUpdate = () => {
    var batchList = document.getElementsByClassName("batches-list");

    var sort = document.getElementsByClassName("newrows");
  };

  //  for handle click

  handleClick = (event) => {
    const id = event.currentTarget.id;

    const baseState = {
      currentHome: "nav-item nav-link",
      prescriptionHome: "nav-item nav-link",
      processedHome: "nav-item nav-link",
      shippedHome: "nav-item nav-link",
      deliverHome: "nav-item nav-link",
      cancelHome: "nav-item nav-link",
      currentHomePanel: "tab-pane fade",
      prescriptionHomePanel: "tab-pane fade",
      processedHomePanel: "tab-pane fade",
      shippedHomePanel: "tab-pane fade",
      deliverHomePanel: "tab-pane fade",
      cancelHomePanel: "tab-pane fade",
      showOrderDetailsProcess: "pharmacy-tab collapse-hide",
      showRejectReasons: "collapse-hide",
      showOrdersGrid: "row showorder-list collapse-show",
      invoiceDiv: "collapse-hide",
      invoicePDFPreview: "collapse-hide",
      retailerOrderMedicineInvoiceDetailsView: [],
      orderId: "",
      subTotal: "0.00",
      totaldiscount: "0.00",
      totalCoupanAmt: "0.00",
      totalpaid: "0.00",
      deliveryCharges: "",
      couponDiscountAmount: "",
    };

    const tabMap = {
      "current_home-tab": { key: "currentHome", panel: "currentHomePanel", status: 1 },
      "prescription_home-tab": { key: "prescriptionHome", panel: "prescriptionHomePanel", status: 2 },
      "processed_home-tab": { key: "processedHome", panel: "processedHomePanel", status: 3 },
      "shipped_home-tab": { key: "shippedHome", panel: "shippedHomePanel", status: 4 },
      "deliver_home-tab": { key: "deliverHome", panel: "deliverHomePanel", status: 5 },
      "cancel_home-tab": { key: "cancelHome", panel: "cancelHomePanel", status: 6 },
    };

    const tab = tabMap[id];
    if (tab) {
      this.setState({
        ...baseState,
        [tab.key]: "nav-item nav-link active",
        [tab.panel]: "tab-pane fade show active",
      });
      if (id === "prescription_home-tab") {
        $("#prescription_home").addClass("collapse-show").removeClass("collapse-hide");
      } else {
        $("#prescription_home").removeClass("collapse-show").addClass("collapse-hide");
      }
      this.retailerOrderDetails(this.state.retailerId, tab.status);
    }
  };

  //  Live OrderBatchRows instances, keyed by medicine id, so the default
  //  allocation can be pushed into them once the table is on screen.
  batchRowRefs = {};

  registerBatchRows = (medicineId, instance) => {
    if (instance) {
      this.batchRowRefs[medicineId] = instance;
    } else {
      delete this.batchRowRefs[medicineId];
    }
  };

  /**
   * Label for one batch in the primary row's dropdown.
   *
   * The dropdown deliberately lists every batch, including the ones FEFO will
   * not touch, so the retailer can still pick one on purpose. Saying why a
   * batch was skipped is what stops an unselected line looking like the
   * auto-selection simply failed.
   */
  batchOptionLabel = (stock) => {
    const base = stock.batch + "/" + stock.expiry_date;
    if (isExpiredBatch(stock.expiry_date)) return base + " (expired)";
    if (toQuantity(stock.quantity) <= 0) return base + " (out of stock)";
    if (String(stock.status) === "0") return base + " (inactive)";
    return base;
  };

  //  The primary row for a line changed. Its batch rows read that row out of
  //  the DOM, so they have to be told when it moves.
  refreshBatchRows = (medicineId) => {
    const rows = this.batchRowRefs[medicineId];
    if (rows) rows.refresh();
  };

  //  An extra batch row changed. Totals are read off the table by class, so
  //  they only need recomputing once the new values are in the DOM.
  onBatchRowsChanged = () => {
    this.getTotals();
    this.forceUpdate();
  };

  /**
   * The batches to default to for one line.
   *
   * The server sends these as suggested_batches, so web and mobile default to
   * the same ones and neither has to keep its own copy of the rules in step.
   * Falling back to the local allocator keeps this screen working against a
   * backend that has not been deployed yet, and during a rollout where the two
   * are briefly out of sync.
   */
  suggestedAllocations = (line) => resolveSuggestedAllocations(line);

  /**
   * Pre-select batches for every line, nearest expiry first.
   *
   * The first batch goes on the row Retailerdashboard renders, and is applied
   * by driving the existing batchSelect handler rather than writing the fields
   * here - that way a suggested batch and a hand-picked one leave the row in
   * exactly the same state. Anything the first batch cannot cover is handed to
   * that line's OrderBatchRows as additional rows.
   */
  applyDefaultBatchSelection = (lines) => {
    const unallocated = [];

    (lines || []).forEach((line) => {
      //  Each line is applied in isolation. This ran as one uninterrupted loop
      //  before, so the first line that threw - a batch that had gone out of
      //  stock, a cell the row does not carry under the retailer's GST type -
      //  left every line after it sitting on "select batch", which reads as
      //  "only the first item gets a batch".
      try {
        if (!this.applyLineBatchSelection(line)) unallocated.push(line);
      } catch (err) {
        console.error(
          "Batch auto-select failed for medicine " + line.medicineId,
          err
        );
        unallocated.push(line);
      }
    });

    this.getTotals();
    this.forceUpdate();

    //  Say so rather than leaving the retailer to notice a dropdown that did
    //  not fill in. Nothing is blocked - they can still pick a batch by hand,
    //  and raising the invoice already refuses a line without one.
    if (unallocated.length > 0) {
      //  Named with why, so "expired stock" is not mistaken for the screen
      //  having failed to fill the dropdown in.
      const names = unallocated
        .map((line) => {
          const reason = unsellableReason(line.stockRows);
          if (!line.productName) return "";
          return reason ? line.productName + " (" + reason + ")" : line.productName;
        })
        .filter(Boolean);
      toast.warn(
        "No in-stock, in-date batch could be selected automatically for " +
          (names.length ? names.join("; ") : unallocated.length + " item(s)") +
          ". Please choose a batch manually."
      );
    }
  };

  /**
   * Apply the default allocation to one line.
   *
   * @returns {boolean} true when a batch was put on the line's primary row.
   */
  applyLineBatchSelection = (line) => {
    const allocations = this.suggestedAllocations(line);
    if (allocations.length === 0) return false;

    const select = document.getElementById("medbatch-" + line.medicineId);
    const billed = document.getElementById("medbqty-" + line.medicineId);
    if (!select) return false;

    //  Match on the stock id inside the option value rather than rebuilding
    //  that "~"-joined string, so the two cannot drift apart.
    const wanted = String(allocations[0].stockId);
    const option = Array.prototype.find.call(
      select.options,
      (opt) => String(opt.value).split("~")[3] === wanted
    );
    if (!option) return false;

    select.value = option.value;
    if (billed) billed.value = allocations[0].qty;
    this.batchSelect({ target: { id: "medbatch-" + line.medicineId } });

    const extraRows = allocations.slice(1);
    const rows = this.batchRowRefs[line.medicineId];
    if (rows && extraRows.length > 0) rows.setRows(extraRows);

    return true;
  };

  //  For batch select

  batchSelect = (event) => {
    let data = document.getElementById(event.target.id).value;
    data = data.split("~");

    let availbelQuantity = Number(data[2]);
    let mrp = data[4];
    let discount = data[6];
    let CGST = data[7];
    let SGST = data[8];
    let IGST = data[9];
    let meddata = event.target.id.split("-");
    let search = event.target.id.search("~");
    if (search > 0) {
      let newRow = meddata[0].split("#");
      let RowId = newRow[0] + "#";

      document.getElementById(RowId + "new~medaqty-" + meddata[1]).value =
        availbelQuantity;
      document.getElementById(RowId + "new~medmrp-" + meddata[1]).value = mrp;
      document.getElementById(RowId + "new~meddiscount-" + meddata[1]).value =
        discount;
      const gstType = this.state.retailerDetails["gst_type"];
      if (gstType === "GST") {
        document.getElementById(RowId + "new~medCGST-" + meddata[1]).value = CGST;
        document.getElementById(RowId + "new~medSGST-" + meddata[1]).value = SGST;
      } else if (gstType === "IGST") {
        document.getElementById(RowId + "new~medIGST-" + meddata[1]).value = IGST;
      }
      // no gst_type → skip tax fields, retailer has no GST
    } else {
      document.getElementById("medaqty-" + meddata[1]).value = availbelQuantity;
      document.getElementById("medmrp-" + meddata[1]).value = mrp;
      document.getElementById("meddiscount-" + meddata[1]).value = discount;
      const gstType = this.state.retailerDetails["gst_type"];
      if (gstType === "GST") {
        document.getElementById("medCGST-" + meddata[1]).value = CGST;
        document.getElementById("medSGST-" + meddata[1]).value = SGST;
      } else if (gstType === "IGST") {
        document.getElementById("medIGST-" + meddata[1]).value = IGST;
      }
      // no gst_type → skip tax fields
    }
    this.caliculateInvoiceAmountsNewRows(event.target.id);
    this.refreshBatchRows(meddata[1]);
  };
  // Get the Order Dashboard Details
  getAllDashboardDetails = (retailerId) => {
    var startDate = this.state.startDate;
    var endDate = this.state.endDate;
    let timeZone = moment.tz.guess();
    Httpconfig.httptokenpost(
      Constant.siteurl + "api/OM/orderProcess/getOrderDashboardDetails/",
      {
        retailerId: retailerId,
        start_date: startDate,
        end_date: endDate,
        timeZone: timeZone,
      }
    )
      .then((response) => {
        if (response.data.status == 200) {
          this.setState({
            pendingOrder: response.data.data[0].pendingOrder,
            shippedOrder: response.data.data[0].shippedOrder,
            cancelledOrder: response.data.data[0].cancelledOrder,
            deliveredOrder: response.data.data[0].deliveredOrder,
            PrescriptionVerifiedOrder: response.data.data[0].previewOrder,
            processingOrder: response.data.data[0].processingOrder,
          });
          this.forceUpdate();
        }
      })
      .catch((error) => {
        toast.error(error);
      });
  };

  // order details list

  retailerOrderDetails = (retailerId, status) => {
    let startDate = "";
    let endDate = "";
    let finalorderarray = [];
    let timeZone = moment.tz.guess();
    startDate = this.state.startDate;
    endDate = this.state.endDate;
    this.getAllDashboardDetails(retailerId);
    this.setState({ isLoading: true });
    Httpconfig.httptokenpost(
      Constant.siteurl + "api/OM/orderProcess/getOrderDetailsweb",
      {
        retailer_id: retailerId,
        start_date: startDate,
        end_date: endDate,
        status: status,
        timeZone: timeZone,
      }
    )
      .then((response) => {
        this.setState({ isLoading: false });
        if (response.data.status == 200) {
          if (Object.keys(response.data.data).length > 0) {
            const retailerFinalOrderMedicineDetailsView =
              response.data.data.map((finalLoadedData, num) => {
                console.log("num-----------", finalLoadedData)
                var patientEmail = "";
                if (finalLoadedData?.patient_tbl == null) {
                  patientEmail = "";
                }
                // else {

                //   patientEmail = finalLoadedData.patient_tbl?.tbl_user.email;
                // }

                if (finalLoadedData.order_status == status) {
                  return (
                    <tr>
                      {" "}
                      <td>{num + 1}</td>
                      <td>
                        {finalLoadedData.delivery_address_tbl?.name
                          ? finalLoadedData.delivery_address_tbl.name
                            .charAt(0)
                            .toUpperCase() +
                          finalLoadedData.delivery_address_tbl.name.slice(1)
                          : ""}{" "}
                        <h6>
                          {finalLoadedData.delivery_address_tbl?.mobile_no || ""}
                        </h6>
                      </td>
                      <td>{finalLoadedData.id || ""}</td>
                      <td>
                        {finalLoadedData.order_date
                          ? dateformatter.asianDateFormat(finalLoadedData.order_date)
                          : ""}
                      </td>
                      <td class="presc_field">
                        {finalLoadedData?.cart_prescriptions_tbls?.[0]?.medical_document?.length > 0 ? (
                          finalLoadedData.cart_prescriptions_tbls[0].medical_document.map((presImages, idx) => (
                            <a
                              key={idx}
                              href={presImages || "#"}
                              target="_blank"
                              rel="noopener noreferrer"
                              title={/\.pdf(\?|$)/i.test(presImages) ? "Click to open PDF" : `Prescription ${idx + 1}`}
                            >
                              {/\.pdf(\?|$)/i.test(presImages) ? (
                                <div style={{
                                  width: 40, height: 40, display: "inline-flex", flexDirection: "column",
                                  alignItems: "center", justifyContent: "center",
                                  background: "#fff3f3", border: "2px solid #dc3545",
                                  borderRadius: 4, marginRight: 5, cursor: "pointer",
                                  fontSize: 9, color: "#dc3545", fontWeight: "bold", verticalAlign: "top",
                                }}>
                                  <span style={{ fontSize: 16, lineHeight: 1 }}>&#128196;</span>
                                  PDF
                                </div>
                              ) : (
                                <img
                                  className="presc_img"
                                  src="../images/retailer/Invoice.svg"
                                  alt={`Prescription ${idx + 1}`}
                                  style={{ width: 40, height: 40, objectFit: "cover", marginRight: 5 }}
                                />
                              )}
                            </a>
                          ))
                        ) : (
                          "----"
                        )}

                        {/* {finalLoadedData?.cart_prescriptions_tbl && finalLoadedData?.cart_prescriptions_tbl[0]?.medical_document
                          ? finalLoadedData.cart_prescriptions_tbl[0].medical_document.map(
                            (presImages, num) => {
                              return (
                                <a
                                  href={
                                    presImages
                                      ?  presImages
                                      : ""
                                    // presImages
                                    //   ? Constant.imgurl + presImages
                                    //   : ""
                                  }
                                  target="_blank"
                                >
                                  <img
                                    class="presc_img"
                                    src="../images/retailer/Invoice.svg"
                                  />
                                </a>
                              );
                            }
                          )
                          : "--"} */}
                      </td>
                      <td>
                        {finalLoadedData.order_processing_tbls &&
                          Object.keys(finalLoadedData.order_processing_tbls).length > 0
                          ? Object.keys(finalLoadedData.order_processing_tbls).length
                          : 0}
                      </td>
                      <td>
                        {Constant.currency}{" "}
                        {finalLoadedData.payable_amount
                          ? parseFloat(finalLoadedData.payable_amount)
                            .toFixed(2)
                            .replace(/\d(?=(\d{3})+\.)/g, "$&,")
                          : "0.00"}
                      </td>
                      <td>
                        {finalLoadedData.payment_method
                          ? finalLoadedData.payment_method.toUpperCase() === "COD"
                            ? "COD"
                            : "ONLINE"
                          : "--"}
                      </td>
                      {finalLoadedData.order_status != 1 ? (
                        <td>
                          {finalLoadedData.invoice != null ? (
                            <a
                              href={
                                finalLoadedData.invoice != null
                                  ? finalLoadedData.invoice // Constant.imgurl + finalLoadedData.invoice
                                  : ""
                              }
                              target="_blank"
                            >
                              {" "}
                              <img
                                class="presc_img"
                                src="../images/retailer/RxFile.svg"
                              />
                            </a>
                          ) : (
                            "--"
                          )}
                        </td>
                      ) : (
                        <td>--</td>
                      )}

                      {finalLoadedData.order_status == 1 ? (
                        <td class="pending_td">
                          {" "}
                          <a
                            class="pending_box"
                            id={finalLoadedData.id}
                            name={
                              finalLoadedData.patient_address_id
                                ? finalLoadedData.patient_address_id
                                : ""
                            }
                            onClick={this.showOrderdetails}
                          >
                            Pending{" "}
                            <img src="../images/retailer/Icon-ionic-ios-arrow-forward.svg" />
                          </a>{" "}
                        </td>
                      ) : (
                        ""
                      )}
                      {finalLoadedData.order_status == 2 ? (
                        <td class="pending_td">
                          {" "}
                          <a
                            class="presc_box"
                            id={finalLoadedData.id}
                            name={finalLoadedData.patient_address_id}
                            onClick={this.prescriptionVerified}
                          >
                            Prescription Verified
                            <img src="../images/retailer/Icon-ionic-ios-arrow-forward.svg" />
                          </a>{" "}
                        </td>
                      ) : (
                        ""
                      )}
                      {finalLoadedData.order_status == 3 ? (
                        <td class="pending_td">
                          {" "}
                          <a
                            class="process_box"
                            id={finalLoadedData.id}
                            onClick={this.ChangeOrderStatus.bind(
                              this,
                              finalLoadedData.id,
                              "4",
                              "Gokada",
                              patientEmail
                            )}
                          >
                            Processed{" "}
                            <img src="../images/retailer/Icon-ionic-ios-arrow-forward.svg" />
                          </a>{" "}
                        </td>
                      ) : (
                        ""
                      )}

                      {finalLoadedData.order_status == "4" ? (
                        <td class="pending_td dropdown">
                          {" "}
                          <a class="shipped_box" id={finalLoadedData.id}>
                            Shipped{" "}
                            <img src="../images/retailer/Icon-ionic-ios-arrow-forward.svg" />
                          </a>
                          <div
                            class="dropdown-menu shipped_item"
                            aria-labelledby="dropdownMenuButton"
                          >
                            <a
                              id={finalLoadedData.id}
                              onClick={this.ChangeOrderStatus.bind(
                                this,
                                finalLoadedData.id,
                                "5",
                                "",
                                patientEmail
                              )}
                            >

                              Delivered
                            </a>

                            <a
                              id={finalLoadedData.id}
                              onClick={this.ChangeOrderStatus.bind(
                                this,
                                finalLoadedData.id,
                                "6",
                                finalLoadedData.delivery_agent,
                                patientEmail
                              )}
                            >

                              Cancel
                            </a>
                          </div>
                        </td>
                      ) : (
                        ""
                      )}
                      {finalLoadedData.order_status == 5 ? (
                        <td class="pending_td">
                          {" "}
                          <a class="delivery_box" id={finalLoadedData.id}>
                            Delivered{" "}
                            {/* <img src="../images/retailer/Icon-ionic-ios-arrow-forward.svg" /> */}
                          </a>{" "}
                        </td>
                      ) : (
                        ""
                      )}
                      {finalLoadedData.order_status == 6 ? (
                        <td class="pending_td">
                          {" "}
                          <a class="cancelled_box" id={finalLoadedData.id}>
                            Cancelled{" "}
                            {/* <img src="../images/retailer/Icon-ionic-ios-arrow-forward.svg"/> */}
                          </a>{" "}
                        </td>
                      ) : (
                        ""
                      )}
                    </tr>
                  );
                }
              });
            this.setState({ retailerFinalOrderMedicineDetailsView, finalorderarray });
          } else {
            this.setState({ retailerFinalOrderMedicineDetailsView: [] });
          }
        }
      })
      .catch((error) => {
        this.setState({ isLoading: false });
        toast.error(error);
      });
  };

  // show order details for process

  showOrderdetails = (event) => {

    //alert("in");
    const orderId = event.currentTarget.id;
    const customerAddressId = event.currentTarget.name;
    let retailerId = this.state.retailerId;
    this.hidegridpendingorders();
    this.setState({ orderId, customerAddressId });
    Httpconfig.httptokenpost(
      Constant.siteurl +
      "api/OM/orderProcess/getOrderDetailsweb/",
      // retailerId +
      // "/" +
      // orderId,
      { customerAddressId, "retailer_id": retailerId, "order_id": orderId }
    )
      .then((response) => {
        if (response.data.status == 200) {
          if (Object.keys(response.data.data).length > 0) {
            // this.setState({
            //   custmerEmail: response.data.data[0].patient_tbl.tbl_user.email,
            // });

            const firstData = response.data.data[0];
            const addrTbl = firstData?.delivery_address_tbl;
            const customerName = addrTbl?.name
              ? addrTbl.name.charAt(0).toUpperCase() + addrTbl.name.slice(1)
              : "";
            const customermobile = addrTbl?.mobile_no || "";
            const retailerName = firstData?.retailer_registration_tbl?.storename || "";
            const amount = firstData?.payable_amount
              ? parseFloat(firstData.payable_amount).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,")
              : "0.00";
            const itemsCount = firstData?.order_processing_tbls?.length || 0;
            const customerId = addrTbl?.patient_id || null;

            const retailerOrderMedicineDetailsView = response.data.data.map(
              (finalLoadedData, num) => {
                // Safe access to nested properties with fallbacks
                this.state.customerName = finalLoadedData.delivery_address_tbl?.name
                  ? finalLoadedData.delivery_address_tbl.name.charAt(0).toUpperCase() +
                  finalLoadedData.delivery_address_tbl.name.slice(1)
                  : "";

                this.state.customermobile = finalLoadedData.delivery_address_tbl?.mobile_no || "";

                this.state.retailerName = finalLoadedData.retailer_registration_tbl?.storename || "";

                this.state.amount = finalLoadedData.payable_amount
                  ? parseFloat(finalLoadedData.payable_amount)
                    .toFixed(2)
                    .replace(/\d(?=(\d{3})+\.)/g, "$&,")
                  : "0.00";

                this.state.itemsCount = finalLoadedData.order_processing_tbls &&
                  Object.keys(finalLoadedData.order_processing_tbls).length > 0
                  ? Object.keys(finalLoadedData.order_processing_tbls).length
                  : 0;

                this.state.customerId = finalLoadedData.delivery_address_tbl?.patient_id || null;



                return (
                  <React.Fragment>
                    {finalLoadedData.order_processing_tbls &&
                      Object.keys(finalLoadedData.order_processing_tbls).length > 0
                      ? finalLoadedData.order_processing_tbls.map(
                        (subData, num) => {
                          return (
                            <React.Fragment>
                              {subData.productMaster_b2c ? (
                                <tr>
                                  <td className="check_bar">
                                    {/* <input
                                    type="checkbox"
                                    className="medidinesList"
                                    name="medidinesList"
                                    id={`${subData.productMaster_b2c.id}-${subData.productMaster_b2c.medicinename}`}
                                  /> */}
                                    <label className="medidinesList" id={`${subData.productMaster_b2c.id}-${subData.productMaster_b2c.medicinename}`}>
                                      {num + 1}
                                    </label>
                                  </td>
                                  {/* <td class="check_bar">
                                    <label
                                      //type="checkbox"
                                      class="medidinesList"
                                      name="medidinesList"
                                      id={
                                        subData.productMaster_b2c.id +
                                        "-" +
                                        subData.productMaster_b2c
                                          .medicinename
                                      }
                                      // onChange={(event) => {
                                      //   $(".medidinesList").prop(
                                      //     "checked",
                                      //     true
                                      //   );
                                      // }}
                                    >{num+1} </label>
                                  </td> */}
                                  <td>
                                    {subData.productMaster_b2c.medicinename}{" "}
                                    <h6>
                                      {
                                        subData.productMaster_b2c
                                          .manufacturer
                                      }
                                    </h6>
                                  </td>

                                  <td>
                                    <div class="qty ">
                                      <input
                                        type="number"
                                        class="count"
                                        name="qty"
                                        id={"txt" + "-" + finalLoadedData.id}
                                        defaultValue={subData.quantity}
                                      />
                                    </div>
                                  </td>
                                  <td>
                                    {Constant.currency} {subData.amount}
                                  </td>
                                </tr>
                              ) : (
                                ""
                              )}
                            </React.Fragment>
                          );
                        }
                      )
                      : ""}
                  </React.Fragment>
                );
              }
            );

            const isPdf = (url) => typeof url === "string" && /\.pdf(\?|$)/i.test(url);

            const renderPrescriptionThumb = (presImages, num) => (
              <a
                key={num}
                href={presImages || "#"}
                target="_blank"
                rel="noopener noreferrer"
                title={isPdf(presImages) ? "Click to open PDF" : `Prescription ${num + 1}`}
              >
                {isPdf(presImages) ? (
                  <div style={{
                    width: 80, height: 80, display: "inline-flex", flexDirection: "column",
                    alignItems: "center", justifyContent: "center",
                    background: "#fff3f3", border: "2px solid #dc3545",
                    borderRadius: 6, marginRight: 5, cursor: "pointer",
                    fontSize: 10, color: "#dc3545", fontWeight: "bold", verticalAlign: "top",
                  }}>
                    <span style={{ fontSize: 28, lineHeight: 1 }}>&#128196;</span>
                    PDF
                  </div>
                ) : (
                  <img
                    className="presc_img"
                    src={presImages}
                    alt={`Prescription ${num + 1}`}
                    style={{ width: 80, height: 80, objectFit: "cover", marginRight: 5, borderRadius: 6 }}
                  />
                )}
              </a>
            );

            const retailerPrescriptionDetailsView = response.data.data.map(
              (finalLoadedData, num) => {
                return (
                  <React.Fragment>
                    {finalLoadedData?.cart_prescriptions_tbls?.[0]?.medical_document?.length > 0
                      ? finalLoadedData.cart_prescriptions_tbls[0].medical_document.map(
                        (presImages, num) => {
                          return (
                            <a
                              key={num}
                              href={presImages || "#"} // open in new tab
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <img
                                className="presc_img"
                                src={presImages || Constant.imgurl + presImages}
                                //src={presImages || Constant.imgurl + presImages} // only prepend if it's a relative URL
                                alt={`Prescription ${num + 1}`}
                                style={{ width: 80, height: 80, objectFit: "cover", marginRight: 5 }}
                              />
                            </a>
                          );
                        }
                      )
                      : <span>Prescription not available</span>}
                  </React.Fragment>

                  // <React.Fragment>
                  //   {finalLoadedData.cart_prescriptions_tbl
                  //     ? finalLoadedData.cart_prescriptions_tbl[0].medical_document.map(
                  //       (presImages, num) => {
                  //         return (
                  //           <a
                  //             href={
                  //               presImages ?  presImages : ""
                  //               //presImages ? Constant.imgurl + presImages : ""
                  //             }
                  //             target="_blank"
                  //           >
                  //             <img
                  //               class="presc_img"
                  //               src={Constant.imgurl + presImages}
                  //             />
                  //           </a>
                  //         );
                  //       }
                  //     )
                  //     : "Prescription not available"}
                  // </React.Fragment>
                );
              }
            );

            $(".nav-item,.nav-link").removeClass("active");
            $("#prescription_home-tab").addClass("active");
            this.setState({
              ordereditems: retailerOrderMedicineDetailsView,
              retailerPrescriptionDetailsView,
              //  Rendered on demand rather than pre-built into state like the
              //  view above, so flagging a prescription updates the panel
              //  without reloading the order.
              orderPrescriptions: firstData?.prescriptions || [],
              //  An order-level request names no document ("nothing uploaded
              //  yet"), so it cannot be spotted from orderPrescriptions - it
              //  has to be carried separately or the approve guard misses it.
              orderLevelReuploadPending:
                !!firstData?.reupload_prescription_required &&
                !(firstData?.prescriptions || []).some(
                  (p) => p.reupload_required
                ),
              //  Some orders contain no product that needs a prescription at
              //  all - the Prescription panel (and its Send Request button)
              //  only makes sense when the order actually has an rx entry.
              requiresPrescription: (firstData?.cart_prescriptions_tbls?.length || 0) > 0,
              customerName,
              customermobile,
              retailerName,
              amount,
              itemsCount,
              customerId,
            });
          }
        }
      })
      .catch((error) => {
        toast.error(error);
      });
  };

  // shortage book quanatity decrement

  qtyDecrement = (event) => {
    let data = event.currentTarget.id.split("-");
    let id = data[0];
    let orderId = data[1];
    let qty = $("#txt-" + id).val();

    if (qty > 0) {
      qty = qty - 1;
      $("#txt-" + id).val(qty);
    }
  };

  // shortage book quanatity Increment
  qtyIncrement = (event) => {
    let data = event.currentTarget.id.split("-");
    let id = data[0];
    let orderId = data[1];
    let qty = $("#txt-" + orderId).val();

    if (qty >= 0) {
      qty = parseInt(qty) + 1;
      $("#txt-" + orderId).val(qty);
    }
  };

  // End date selection

  startDate = (field, event) => {
    let startDate = event.target.value;
    // Clearing the input hands back "", which moment would turn into
    // "Invalid date" and send straight to the search API.
    this.state.startDate = startDate ? moment(startDate).format("YYYY-MM-DD") : "";

    if (field == "startDate") {
      let count = startDate.search("-");
      if (count > 0) {
        let dateString = startDate.split("-");
        if (dateString[0].length != 4) {
          toast.error("Invalid date formate");
        }
      }
    }
    this.forceUpdate();
  };

  // Start date selection
  endDate = (field, event) => {
    let endDate = event.target.value;
    this.state.endDate = endDate ? moment(endDate).format("YYYY-MM-DD") : "";

    if (field == "endDate") {
      let count = endDate.search("-");

      if (count > 0) {
        let dateString = endDate.split("-");
        if (dateString[0].length != 4) {
          toast.error("Invalid date formate");
        }
      }
    }
    this.forceUpdate();
  };
  //  For show order dates
  showOrderbyDates = () => {
    let start_date = $("#start_date").val();
    let end_date = $("#end_date").val();

    if (start_date != "" && end_date != "") {
      if (start_date > end_date) {
        toast.error("From date  do not  greater than todate ");
        return;
      }
      let id = $(".p_nav").find(".active").attr("id");

      if (id == "current_home-tab") {
        this.retailerOrderDetails(this.state.retailerId, 1);
        this.showgridpendingorders();
      }
      if (id == "prescription_home-tab") {
        this.retailerOrderDetails(this.state.retailerId, 2);
        this.showgridpendingorders();
      }
      if (id == "processed_home-tab") {
        this.retailerOrderDetails(this.state.retailerId, 3);
        this.showgridpendingorders();
      }

      if (id == "shipped_home-tab") {
        this.retailerOrderDetails(this.state.retailerId, 4);
        this.showgridpendingorders();
      }
      if (id == "deliver_home-tab") {
        this.retailerOrderDetails(this.state.retailerId, 5);
        this.showgridpendingorders();
      }
      if (id == "cancel_home-tab") {
        this.retailerOrderDetails(this.state.retailerId, 6);
        this.showgridpendingorders();
      }
    } else {
      toast.error("Please select dates");
    }
  };

  // show grid and hide pending order details

  showgridpendingorders = () => {
    this.setState({
      showOrderDetailsProcess: "pharmacy-tab collapse-hide",
      showOrdersGrid: "row showorder-list collapse-show",
      showRejectReasons: "collapse-hide",
      invoiceDiv: "collapse-hide",
      invoicePDFPreview: "collapse-hide",
      retailerOrderMedicineInvoiceDetailsView: [],
      orderId: "",
      subTotal: "0.00",
      totaldiscount: "0.00",
      totalCoupanAmt: "0.00",
      totalpaid: "0.00",
      deliveryCharges: "",
      couponDiscountAmount: "",
    });
  };

  // hide grid and show pending order details

  hidegridpendingorders = () => {
    this.setState({
      showOrderDetailsProcess: "pharmacy-tab collapse-show",
      showOrdersGrid: "row showorder-list collapse-hide",
      showRejectReasons: "collapse-hide",
    });
  };
  //  For navigation
  back = () => {
    this.showgridpendingorders();
  };

  // update the cancellation reaon

  cancelReason = (event) => {
    $(".rej_check").prop("checked", false);
    $("#" + event.currentTarget.id).prop("checked", true);

    let id = event.currentTarget.id.split("_")[1];
    this.setState({ orderRejectReason: event.currentTarget.value });

    if (document.getElementById(event.currentTarget.id).checked == true) {
      this.state.cancelleReason = id;
    } else {
      this.state.cancelleReason = "";
    }
  };
  // reject order show div

  rejectOrderShow = () => {

    //$('input[name="medidinesList"]').prop('checked', true);
    // let deliveryAgentCheckedCount = $(
    //   'input[name="medidinesList"]:checked'
    // ).length;
    // if (deliveryAgentCheckedCount == 0) {
    //   toast.error("Select Available Medicines");
    // } else {
    this.state.showOrderDetailsProcess = "pharmacy-tab collapse-hide";
    //this.state.showOrdersGrid = "row showorder-list collapse-hide";
    this.state.showRejectReasons = "collapse-show";
    this.getRejectionResonslist();
    this.forceUpdate();
    //}
  };
  //  For getting rejection reason list
  getRejectionResonslist = () => {
    Httpconfig.httptokenget(Constant.siteurl + "api/OM/cancellationReason/")
      .then((response) => {
        if (response.data.status == 200) {
          if (Object.keys(response.data.data).length > 0) {
            const retailerRejectList = response.data.data.map(
              (finalLoadedData, num) => {
                return (
                  <p>
                    <input
                      type="checkbox"
                      class="rej_check"
                      name="cancelReasons"
                      id={"rejid_" + finalLoadedData.id}
                      value={finalLoadedData.reason}
                      onChange={this.cancelReason}
                    />{" "}
                    {finalLoadedData.reason}
                  </p>
                );
              }
            );
            this.state.retailerRejectList = retailerRejectList;
            this.forceUpdate();
          }
        }
      })
      .catch((error) => {
        toast.error(error);
      });
  };
  //  For reject order
  rejectOrder = () => {
    let cancelReasonsCheckedCount = $(
      'input[name="cancelReasons"]:checked'
    ).length;
    if (cancelReasonsCheckedCount == 0) {
      toast.error("Select Reason for Cancellation");
      return;
    } else {
      let orderId = this.state.orderId;
      let cancelledReason = this.state.cancelleReason;
      let orderRejectReason = this.state.orderRejectReason;
      let custmerEmail = this.state.custmerEmail;
      Httpconfig.httptokenpost(
        Constant.siteurl + "api/OM/cancellationReason/orderDetails/" + orderId,
        {
          order_status: "6",
          cancelled_reason: cancelledReason,
          orderRejectReason,
          custmerEmail,
        }
      )
        .then((response) => {
          if (response.data.status == 200) {
            toast.success(response.data.message);
            window.location.reload();
          }
        })
        .catch((error) => {
          toast.error(error);
        });
    }
  };

  // Create Order in Gokada
  createOrder = (orderId, deliveryAgent) => {
    Httpconfig.httptokenpost(
      Constant.siteurl +
      "api/OM/orderProcess/getOrderDetailsweb",
      // this.state.retailerId +
      // "/" +
      // orderId,
      { "retailer_id": this.state.retailerId, "order_id": orderId }
    )
      .then((response) => {
        if (response.data.status == 200) {
          // Safe access with null checks
          const orderData = response.data.data?.[0];

          if (!orderData) {
            console.warn(
              "Skipping " + deliveryAgent + " booking for order " + orderId + ": order details not returned"
            );
            return;
          }

          let pickupAddress = orderData.retailer_registration_tbl?.address || "";
          let pickupLatitude = orderData.retailer_registration_tbl?.latitude || "";
          let pickupLongitude = orderData.retailer_registration_tbl?.longitude || "";
          let pickupName = orderData.retailer_registration_tbl?.storename || "";
          let pickupPhone = orderData.retailer_registration_tbl?.mobile_number || "";
          let pickupEmail = "rakesh.n@medleymed.com";

          //  getOrderDetailsweb returns the address as a single belongsTo on the
          //  order (delivery_address_tbl, via patient_address_id) - the same key
          //  the dashboard grid reads. The legacy nested patient_tbl shape is
          //  kept as a fallback in case an older response is served.
          const legacyAddress = orderData.patient_tbl?.delivery_address_tbls;
          const deliveryAddressTbl =
            orderData.delivery_address_tbl ||
            (Array.isArray(legacyAddress) ? legacyAddress[0] : legacyAddress);

          if (!deliveryAddressTbl) {
            //  The order status update above already succeeded, so this only
            //  means the courier could not be booked - warn instead of showing
            //  the retailer a failure toast they cannot act on.
            console.warn(
              "Skipping " + deliveryAgent + " booking for order " + orderId + ": no delivery address on the order"
            );
            return;
          }

          let deliveryAddress = deliveryAddressTbl.address || "";
          let deliveryLatitude = deliveryAddressTbl.latitude || "";
          let deliveryLongitude = deliveryAddressTbl.longitude || "";
          let deliveryName = deliveryAddressTbl.name || "";
          let deliveryPhone = deliveryAddressTbl.mobile_no || "";
          let deliveryEmail = "rakesh.n@medleymed.com";
          let apiKey = Constant.gokadaApiKey;

          let delivery = {
            api_key: apiKey,
            pickup_address: pickupAddress,
            pickup_latitude: pickupLatitude,
            pickup_longitude: pickupLongitude,
            delivery_address: deliveryAddress,
            delivery_latitude: deliveryLatitude,
            delivery_longitude: deliveryLongitude,
            pickup_name: pickupName,
            pickup_phone: "+234" + pickupPhone,
            pickup_email: pickupEmail,
            delivery_name: deliveryName,
            delivery_phone: "+234" + deliveryPhone,
            delivery_email: deliveryEmail,
            description: orderId,
          };

          Httpconfig.httptokenpost(
            "https://api.gokada.ng/api/developer/order_create",
            delivery
          )
            .then((response) => { })
            .catch((error) => {
              //  Courier dispatch is a side effect of the status change, which
              //  has already been saved and toasted as successful. Surfacing
              //  this as an error toast reads as if the order itself failed.
              console.error(
                deliveryAgent + " booking failed for order " + orderId,
                error
              );
            });
        }
      })
      .catch((error) => {
        console.error(
          "Could not load order " + orderId + " for " + deliveryAgent + " booking",
          error
        );
      });
  };

  /* change order status */

  ChangeOrderStatus = (orderId, status, deliveryAgent, patientEmail) => {

    Httpconfig.httptokenput(
      Constant.siteurl + "api/OM/orderProcess/retailerOrderStatus/" + orderId,
      { order_status: status, patientEmail: patientEmail }
    )
      .then((response) => {
        if (response.data.status == 200) {
          toast.success(response.data.message);
          $(".nav-item,.nav-link").removeClass("active");
          if (status == 1) {
            $("#current_home-tab").addClass("active");
          }
          if (status == 2) {
            $("#prescription_home-tab").addClass("active");
          }
          if (status == 3) {
            $("#processed_home-tab").addClass("active");
            $("#prescription_home").addClass("collapse-hide");
          }
          if (status == 4) {
            $("#shipped_home-tab").addClass("active");
          }
          if (status == 5) {
            $("#deliver_home-tab").addClass("active");
          }
          if (status == 6) {
            $("#cancel_home-tab").addClass("active");
          }
          this.getAllDashboardDetails(this.state.retailerId);
          this.retailerOrderDetails(this.state.retailerId, status);

          if (deliveryAgent == "Gokada") {
            this.createOrder(orderId, deliveryAgent);
          }
        }
      })
      .catch((error) => {
        toast.error(error);
      });
  };
  //  For addrow
  addRow = (event) => {
    let data = event.currentTarget.id;
    let rawData = data.split("-");
    let rowName = rawData[0];
    let rowId = rawData[1];
    let quantity = $("#medqty-" + rowId).val();
    let vat = $("#medvat-" + rowId).val();
    let dynamicadded = $("#medadded-" + rowId).val();
    dynamicadded = Number(dynamicadded) + 1;
    $("#medadded-" + rowId).val(dynamicadded);
    let medpname = $("#medpname-" + rowId).html();

    const newrow = (
      <tr id={dynamicadded + "#new-" + rowId}>
        <td></td>
        <td class="item_inp">
          <div class="collapse-hide">{medpname}</div>
        </td>

        <td class="batch_inp">
          <select
            class="form-control newrowsselect batches-list"
            id={dynamicadded + "#new~medbatch-" + rowId}
            onClick={this.getBatches.bind(this, "new~medbatch-" + rowId)}
          >
            <option>select batch</option>
          </select>
        </td>
        <td class="oqty_inp">
          <input
            type="hidden"
            class="form-control newrows"
            id={dynamicadded + "#new~medqty-" + rowId}
            defaultValue={quantity}
            readOnly={true}
          />
        </td>
        <td class="aqty_inp">
          <input
            type="text"
            class="form-control newrows"
            id={dynamicadded + "#new~medaqty-" + rowId}
            defaultValue="0"
            readOnly="readOnly"
            onBlur={this.caliculateInvoiceAmounts}
          />
        </td>
        <td class="bqty_inp">
          <input
            type="text"
            class="form-control newrows"
            id={dynamicadded + "#new~medbqty-" + rowId}
            defaultValue="0"
            onBlur={this.caliculateInvoiceAmounts}
          />
        </td>

        <td class="tax_inp">
          <input
            type="text"
            class="form-control newrows"
            id={dynamicadded + "#new~medtaxamt-" + rowId}
            defaultValue="0"
            readOnly={true}
          />
        </td>
        <td class="vat_inp">
          <input
            type="text"
            class="form-control newrows"
            id={dynamicadded + "#new~medvat-" + rowId}
            defaultValue={vat}
            onBlur={this.caliculateInvoiceAmounts}
          />
        </td>
        <td class="vatamt_inp">
          <input
            type="text"
            class="form-control newrows"
            id={dynamicadded + "#new~medvatamt-" + rowId}
            defaultValue="0"
            readOnly={true}
          />
        </td>
        <td class="mrp_inp">
          <input
            type="text "
            class="form-control newrows"
            id={dynamicadded + "#new~medmrp-" + rowId}
            defaultValue=""
            onBlur={this.caliculateInvoiceAmounts}
          />
        </td>
        <td class="disc_inp">
          <input
            type="text"
            class="form-control newrows"
            id={dynamicadded + "#new~meddiscount-" + rowId}
            defaultValue="0.00"
            onBlur={this.caliculateInvoiceAmounts}
          />{" "}
        </td>
        <td class="amount_inp">
          <input
            type="text"
            class="form-control newrows"
            id={dynamicadded + "#new~medamount-" + rowId}
            value="0"
            readOnly={true}
          />
        </td>
        <td class="amounts_inp">
          <img
            class="plus_img removebatch newrows"
            onClick={this.removeBatch}
            src="https://cdn1.iconfinder.com/data/icons/essential-free/48/12-Delete-512.png"
            id={dynamicadded + "#new~medadd-" + rowId}
          />
        </td>
      </tr>
    );

    this.state.newRow = newrow;
    this.forceUpdate();
    let parentTR = $("#" + event.currentTarget.id).closest("tr");
    $("#newRow").children().clone(true, true).insertAfter(parentTR);
  };
  //  For get template row
  getTemplateRow = () => {
    let maxID = 0;
    var x = document.getElementById("templateRow").cloneNode(true);
    x.id = "";
    x.style.display = "";
    x.innerHTML = x.innerHTML.replace(/{​​​​​​​​id}​​​​​​​​/, ++maxID);
    return x;
  };

  //  Prescriptions the retailer has asked the customer to replace and which
  //  have not come back yet. Approving would clear the request without the
  //  replacement ever arriving, leaving the order to be dispensed against the
  //  document the retailer already rejected.
  pendingReuploads = () =>
    (this.state.orderPrescriptions || []).filter((p) => p.reupload_required);

  hasPendingReupload = () =>
    this.pendingReuploads().length > 0 ||
    !!this.state.orderLevelReuploadPending;

  // Approve order items
  orderApprove = (event) => {
    const addressId = event.currentTarget.name;

    if (this.hasPendingReupload()) {
      const labels = this.pendingReuploads()
        .map((p) => p.label)
        .filter(Boolean);
      toast.error(
        labels.length
          ? "Cannot approve - waiting for the customer to re-upload " +
              labels.join(", ") +
              "."
          : "Cannot approve - waiting for the customer to upload the requested prescription."
      );
      return;
    }

    // let deliveryAgentCheckedCount = $(
    //   'input[name="medidinesList"]:checked'
    // ).length;
    // if (deliveryAgentCheckedCount == 0) {
    //   toast.error("Select Available Medicines");
    // } else {
    let medicine_details = [];
    let rawData = "";
    let medicineId = "";
    let medicineName = "";
    $("input[name='medidinesList']").each(function () {
      rawData = $(this).attr("id").split("-");
      medicineId = rawData[0];
      medicineName = rawData[1];
      medicine_details.push({
        medicine_id: medicineId,
        medicine_name: medicineName,
      });
    });
    let data = {
      patient_id: this.state.customerId,
      retailer_id: this.state.retailerId,
      order_id: this.state.orderId,
      medicine_details: medicine_details,
    };
    Httpconfig.httptokenpost(
      Constant.siteurl + "api/OM/orderProcess/updateOrderStatus",
      data
    )
      .then((response) => {
        if (response.data.status == 200 && !response.data.error) {
          toast.success(response.data.message);
          this.setState({
            invoiceDiv: "collapse-show",
            invoicePDFPreview: "collapse-hide",
            showOrderDetailsProcess: "pharmacy-tab collapse-hide",
          });
          $(".nav-item, .nav-link").removeClass("active");
          $("#processed_home-tab").addClass("active");
          this.getAllDashboardDetails(this.state.retailerId);
          this.showOrderdetailsInvoice(addressId);
        } else {
          toast.error(response.data.message);
        }
      })
      .catch((error) => {
        toast.error(error);
      });
    //}
  };
  // Get the Retailer Details
  getRetailerDetails = (retailerId) => {
    Httpconfig.httptokenget(Constant.siteurl + "api/retailer/" + retailerId)
      .then((response) => {
        if (response.data.status == 200 && !response.data.error) {
          this.setState({ retailerDetails: response.data.data[0] });
          this.setState({ deliverymode: response.data.data[0].set_delivery_mode })
          //console.log("Resone-------------",response.data.data[0]);
        }
      })
      .catch((error) => {
        toast.error(error);
      });
  };
  //  For verfied prescription
  prescriptionVerified = (event) => {
    const orderId = event.currentTarget.id;
    const patientAddressId = event.currentTarget.name;
    this.setState({
      invoiceDiv: "collapse-show",
      invoicePDFPreview: "collapse-hide",
      showOrderDetailsProcess: "pharmacy-tab collapse-hide",
      orderId: orderId,
      patientAddressId: patientAddressId,
    });
    $(".nav-item, .nav-link").removeClass("active");
    $("#processed_home-tab").addClass("active");
    this.hidegridpendingorders();
    this.showOrderdetailsInvoice(patientAddressId, orderId);
  };

  // show order details for Create Invoice process

  showOrderdetailsInvoice = (addressId, orderId) => {
    const resolvedOrderId = orderId || this.state.orderId;
    let retailerId = this.state.retailerId;
    this.setState({ customerAddressId: addressId });
    let totaldiscount = 0;
    let totalTaxableAmt = 0;
    let subTotal = 0;
    let deliveryCharges = 0;
    let customerAddressId = addressId;
    var totalPaidAmt = 0;

    Httpconfig.httptokenpost(
      Constant.siteurl +
      "api/OM/orderProcess/getOrderDetailsweb",
      { customerAddressId, "retailer_id": retailerId, "order_id": resolvedOrderId }
    )
      .then((response) => {
        if (response.data.status == 200) {
          // console.log("data--------------------", response.data.data)
          if (Object.keys(response.data.data).length > 0) {
            const firstData = response.data.data[0];
            const addrTbl = firstData?.delivery_address_tbl;
            const storeData = firstData?.retailer_registration_tbl || {};
            const hasAddr = addrTbl && Object.keys(addrTbl).length > 0;
            const hasStore = storeData && Object.keys(storeData).length > 0;
            var total_mrp = firstData?.total_mrp || 0;
            let totalTaxesAccum = 0;

            //  Collected while the rows are built so the default batch
            //  allocation can be applied once they are mounted.
            const invoiceLines = [];

            const retailerOrderMedicineInvoiceDetailsView =
              response.data.data.map((finalLoadedData, count) => {

                return (
                  <React.Fragment>
                    {(finalLoadedData.order_processing_tbls || []).length > 0
                      ? (finalLoadedData.order_processing_tbls || []).map(
                        (subData, num) => {

                          //  Every batch of this medicine the retailer holds,
                          //  nearest expiry first. The association is a hasMany
                          //  but older responses sent a single object, so both
                          //  shapes are normalised before sorting.
                          const lineStockRows = sortBatchesByExpiry(
                            Array.isArray(subData.retailer_stock_tbl)
                              ? subData.retailer_stock_tbl
                              : subData.retailer_stock_tbl
                                ? [subData.retailer_stock_tbl]
                                : []
                          );

                          invoiceLines.push({
                            medicineId: subData.medicine_id,
                            //  Named so a line that could not be allocated can
                            //  be reported as the medicine the retailer sees,
                            //  not as an id.
                            productName:
                              subData.productMaster_b2c?.medicinename || "",
                            orderedQty: subData.quantity,
                            stockRows: lineStockRows,
                            suggestedBatches: subData.suggested_batches,
                          });

                          let amounttot = subData.amount
                            ? parseFloat(subData.amount.toString().replace(/,/g, ""))
                            : 0;
                          let discountAmt = amounttot * parseFloat(subData.discount || 0) / 100;
                          let netbill = amounttot - discountAmt;

                          let GST = 0;
                          let totalGST = 0;
                          let CGST = 0;
                          let SGST = 0;
                          const gstType = this.state.retailerDetails["gst_type"];

                          if (gstType === "GST") {
                            if (subData.SGST != "" && subData.CGST != "")
                              GST = parseFloat(subData.SGST) + parseFloat(subData.CGST);
                          } else if (gstType === "IGST") {
                            if (subData.IGST != "")
                              GST = parseFloat(subData.IGST);
                          }
                          // no gst_type → GST stays 0, no tax applied

                          //  GST here is a percentage, so it has to be divided by
                          //  100 before it can be used as a rate: without it 5%
                          //  divided the line by 6 instead of 1.05, and the same
                          //  omission below multiplied the tax by 2.5 rather than
                          //  0.025. Matches caliculateInvoiceAmounts, which is
                          //  what overwrites these cells once a batch is picked.
                          let taxableamt =
                            GST > 0 ? netbill / (1 + GST / 100) : netbill;
                          if (gstType === "GST") {
                            if (subData.SGST != "" && subData.CGST != "") {
                              CGST = (taxableamt * parseFloat(subData.CGST)) / 100;
                              SGST = (taxableamt * parseFloat(subData.SGST)) / 100;
                              totalGST = CGST + SGST;
                            }
                          } else if (gstType === "IGST") {
                            totalGST = netbill - taxableamt;
                          }
                          // no gst_type → totalGST stays 0
                          // console.log("-----subTotal---", subTotal + "-----amounttot---", amounttot); 
                          totalPaidAmt = totalPaidAmt + amounttot;
                          subTotal = subTotal + amounttot;
                          if (subData.discount == null) { subData.discount = 0; }
                          totaldiscount = parseFloat(totaldiscount) + parseFloat(subData.discount);
                          totalTaxableAmt = totalTaxableAmt + taxableamt;
                          totalTaxesAccum += totalGST;

                          return (
                            <React.Fragment>
                              <tr id={"tr-" + num + 1}>
                                <td>{num + 1}</td>
                                <td class="item_inp">
                                  <div id={"medpname-" + subData.medicine_id}>
                                    {" "}
                                    {subData.productMaster_b2c?.medicinename || "N/A"}{" "}
                                    <h6>
                                      {subData.productMaster_b2c?.manufacturer || ""}
                                    </h6>
                                  </div>
                                </td>

                                <td class="batch_inp">
                                  <select
                                    class="form-control batches-list"
                                    id={"medbatch-" + subData.medicine_id}
                                    onChange={this.batchSelect}
                                  >
                                    <option
                                      value="select batch"
                                      disabled
                                      selected
                                    >
                                      select batch
                                    </option>
                                    {lineStockRows.map((option) => {
                                      return (
                                        <option
                                          class="batchselect"
                                          id={option.medicine_id}
                                          value={
                                            option.batch +
                                            "~" +
                                            option.expiry_date +
                                            "~" +
                                            option.quantity +
                                            "~" +
                                            option.id +
                                            "~" +
                                            option.mrp +
                                            "~" +
                                            option.medicine_id +
                                            "~" +
                                            option.discount +
                                            "~" +
                                            option.CGST +
                                            "~" +
                                            //  Position 8 is read back as SGST
                                            //  by batchSelect. It used to repeat
                                            //  CGST, so a batch whose two rates
                                            //  differ was billed at twice its
                                            //  CGST. Falls back to CGST only
                                            //  when the stock row carries no
                                            //  SGST at all, which is what the
                                            //  duplication had been masking.
                                            (option.SGST !== null &&
                                              option.SGST !== undefined &&
                                              option.SGST !== ""
                                              ? option.SGST
                                              : option.CGST) +
                                            "~" +
                                            option.IGST
                                          }
                                        >
                                          {this.batchOptionLabel(option)}
                                        </option>
                                      );
                                    }
                                    )}
                                  </select>
                                </td>

                                <td class="oqty_inp">
                                  <input
                                    type="text"
                                    class="form-control"
                                    id={"medqty-" + subData.medicine_id}
                                    defaultValue={+subData.quantity}
                                    readOnly={true}
                                  />
                                </td>
                                <td class="aqty_inp">
                                  <input
                                    type="text"
                                    class="form-control"
                                    id={"medaqty-" + subData.medicine_id}
                                    defaultValue="0"
                                    readOnly="readOnly"
                                    onBlur={this.caliculateInvoiceAmounts}
                                  />
                                </td>
                                <td class="bqty_inp">
                                  <input
                                    type="text"
                                    class="form-control"
                                    id={"medbqty-" + subData.medicine_id}
                                    defaultValue={+subData.quantity}
                                    onBlur={this.caliculateInvoiceAmounts}
                                  />
                                </td>

                                <td class="tax_inp">
                                  <input
                                    type="text"
                                    class="form-control"
                                    id={"medtaxamt-" + subData.medicine_id}
                                    //  The tax, not the taxable value. This cell
                                    //  sits under the GST heading and is what
                                    //  caliculateInvoiceAmounts writes the tax
                                    //  into once a batch is picked; seeding the
                                    //  taxable value here made an untouched line
                                    //  read as though the whole amount were tax.
                                    defaultValue={totalGST.toFixed(2)}
                                    readOnly={true}
                                  />
                                </td>
                                {this.state.retailerDetails["gst_type"] ==
                                  "GST" ? (
                                  <React.Fragment>
                                    <td class="cgst_inp">
                                      <input
                                        type="text"
                                        class="form-control"
                                        id={"medCGST-" + subData.medicine_id}
                                        defaultValue={
                                          subData.CGST != "" &&
                                            subData.SGST != ""
                                            ? parseFloat(subData.CGST)
                                            : "0"
                                        }
                                        onBlur={this.caliculateInvoiceAmounts}
                                      />
                                    </td>
                                    <td class="sgst_inp">
                                      <input
                                        type="text"
                                        class="form-control"
                                        id={"medSGST-" + subData.medicine_id}
                                        defaultValue={
                                          subData.CGST != "" &&
                                            subData.SGST != ""
                                            ? parseFloat(subData.SGST)
                                            : "0"
                                        }
                                        onBlur={this.caliculateInvoiceAmounts}
                                      />
                                    </td>
                                  </React.Fragment>
                                ) : (
                                  <td class="igst_inp">
                                    <input
                                      type="text"
                                      class="form-control"
                                      id={"medIGST-" + subData.medicine_id}
                                      defaultValue={parseFloat(subData.IGST)}
                                      onBlur={this.caliculateInvoiceAmounts}
                                    />
                                  </td>
                                )}

                                <td class="vatamt_inp">
                                  <input
                                    type="text"
                                    class="form-control"
                                    id={"medvatamt-" + subData.medicine_id}
                                    //  The taxable value - this cell sits under
                                    //  the "Taxable Amt" heading, and is where
                                    //  caliculateInvoiceAmounts puts it.
                                    defaultValue={taxableamt.toFixed(2)}
                                    readOnly={true}
                                  />
                                </td>
                                <td class="mrp_inp">
                                  <input
                                    type="text"
                                    class="form-control"
                                    id={"medmrp-" + subData.medicine_id}
                                    defaultValue={subData.amount}
                                    readOnly={true}
                                    onBlur={this.caliculateInvoiceAmounts}
                                  />
                                </td>
                                <td class="disc_inp">
                                  <input
                                    type="text"
                                    class="form-control"
                                    id={"meddiscount-" + subData.medicine_id}
                                    defaultValue={parseFloat(subData.discount || 0).toFixed(2)}
                                    onBlur={this.caliculateInvoiceAmounts}
                                  />
                                </td>
                                <td class="amount_inp">
                                  <input
                                    type="text"
                                    class="form-control"
                                    id={"medamount-" + subData.medicine_id}
                                    value={(
                                      subData.quantity *
                                      parseFloat(
                                        subData.amount.replace(/,/g, "")
                                      )
                                    )
                                      .toFixed(2)
                                      .replace(/\d(?=(\d{3})+\.)/g, "$&,")}
                                    readOnly={true}
                                  />
                                </td>
                              </tr>

                              {/*  Any batch after the first one for this line.
                                  Kept in its own component so adding a batch
                                  re-renders only these rows - the row above is
                                  a stored element whose values live in the DOM. */}
                              <OrderBatchRows
                                medicineId={subData.medicine_id}
                                productName={
                                  subData.productMaster_b2c?.medicinename || ""
                                }
                                orderedQty={subData.quantity}
                                stockRows={lineStockRows}
                                gstType={this.state.retailerDetails["gst_type"]}
                                register={this.registerBatchRows}
                                onChange={this.onBatchRowsChanged}
                              />
                            </React.Fragment>
                          );
                        }
                      )
                      : ""}
                  </React.Fragment>
                );
              });
            const fmt = n => parseFloat(n || 0).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,");
            const deliveryAmt = parseFloat(firstData?.delivery_charges || 0);
            this.setState({
              retailerOrderMedicineInvoiceDetailsView,
              customerId: addrTbl?.patient_id || "",
              customerName: hasAddr && addrTbl.name
                ? addrTbl.name.charAt(0).toUpperCase() + addrTbl.name.slice(1)
                : "",
              customermobile: addrTbl?.mobile_no || "",
              zipcode: addrTbl?.zipcode || "",
              deliveryCharges: firstData?.delivery_charges || "",
              deliverymode: firstData?.delivery_type || "",
              couponDiscountAmount: firstData?.coupon_amount || "",
              payment_mode: firstData?.payment_method || firstData?.payment_mode || "Online",
              coupan_value: firstData?.coupan_value != null
                ? firstData.coupan_value.replace(/%/g, "")
                : "",
              customerAddress1: hasAddr ? (addrTbl.location || "") : "",
              customerAddress2: hasAddr ? (addrTbl.address || "") : "",
              customerLandmark: hasAddr ? (addrTbl.landmark || "") : "",
              orderId: firstData?.id || this.state.orderId,
              orderDate: firstData?.order_date || "",
              invoiceDateTime: moment().format("YYYY-MM-DD HH:mm:ss"),
              storeName: hasStore ? (storeData.storename || "") : "",
              storeAddress: hasStore ? (storeData.address || "") : "",
              storeMobileNumber: hasStore ? (storeData.mobile_number || "") : "",
              storeregistrationNumber: hasStore ? (storeData.registration_number || "") : "",
              totalPaidAmt: fmt(subTotal),
              subTotal: fmt(subTotal),
              totaldiscount: fmt(totaldiscount),
              totalTaxableAmount: fmt(totalTaxableAmt),
              totalTaxes: fmt(totalTaxesAccum),
            }, () => {
              this.getTotals();
              this.forceUpdate();
              this.applyDefaultBatchSelection(invoiceLines);
            });
          }
        }
      })
      .catch((error) => {
        console.log("eroor-------", error)
        toast.error(error);
      });
  };

  // line wide and column wide

  caliculateInvoiceAmounts = (event) => {
    let data = event.currentTarget.id;
    let rawData = data.split("-");
    let rowName = rawData[0];
    let rowId = rawData[1];
    let subTotal = 0;
    let totaldiscount = 0;
    let totalTaxableAmt = 0;
    let search = data.search("~");
    let mrp = "";
    let billedQty = "";
    let taxamount = "";
    let medvat = "";
    let medvatamt = "";
    let meddiscount = "";
    let medamount = "";
    let availableQty = "";

    if (search > 0) {
      mrp = document.getElementById("new~medmrp-" + rowId).value;
      billedQty = document.getElementById("new~medbqty-" + rowId).value;
      taxamount = document.getElementById("new~medtaxamt-" + rowId).value;
      if (this.state.retailerDetails["gst_type"] == "GST") {
        medvat =
          parseFloat(document.getElementById("new~medCGST-" + rowId).value) +
          parseFloat(document.getElementById("new~medSGST-" + rowId).value);
      } else {
        medvat = parseFloat(
          document.getElementById("new~medIGST-" + rowId).value
        );
      }
      medvatamt = document.getElementById("new~medvatamt-" + rowId).value;
      meddiscount = document.getElementById("new~meddiscount-" + rowId).value;
      medamount = document.getElementById("new~medamount-" + rowId).value;
      availableQty = document.getElementById("new~medaqty-" + rowId).value;
      if (parseInt(billedQty) > parseInt(availableQty)) {
        toast.error(
          "Billed Quantity should not greater than Available Quantity"
        );
        return false;
      }
    } else {
      mrp = document.getElementById("medmrp-" + rowId).value;
      billedQty = document.getElementById("medbqty-" + rowId).value;
      taxamount = document.getElementById("medtaxamt-" + rowId).value;
      if (this.state.retailerDetails["gst_type"] == "GST") {
        medvat =
          parseFloat(document.getElementById("medCGST-" + rowId).value) +
          parseFloat(document.getElementById("medSGST-" + rowId).value);
      } else {
        medvat = parseFloat(document.getElementById("medIGST-" + rowId).value);
      }
      medvatamt = document.getElementById("medvatamt-" + rowId).value;
      meddiscount = document.getElementById("meddiscount-" + rowId).value;
      medamount = document.getElementById("medamount-" + rowId).value;
      availableQty = document.getElementById("medaqty-" + rowId).value;
      if (parseInt(billedQty) > parseInt(availableQty)) {
        toast.error(
          "Billed Quantity should not greater than Available Quantity"
        );
        return false;
      }
    }

    let amt = mrp * billedQty;

    totaldiscount = parseInt((amt * meddiscount) / 100);
    let netbill = amt - parseInt((amt * meddiscount) / 100);
    let taxableamt = netbill / (1 + medvat / 100);
    let vatamount = netbill - taxableamt;
    let amounttot = netbill;
    subTotal = subTotal + netbill;

    this.state.totaldiscount = totaldiscount
      .toFixed(2)
      .replace(/\d(?=(\d{3})+\.)/g, "$&,");

    if (search > 0) {
      document.getElementById("new~medtaxamt-" + rowId).value =
        vatamount.toFixed(2);
      document.getElementById("new~medvatamt-" + rowId).value =
        taxableamt.toFixed(2);
      document.getElementById("new~medamount-" + rowId).value =
        amounttot.toFixed(2);
    } else {
      document.getElementById("medtaxamt-" + rowId).value =
        vatamount.toFixed(2);
      document.getElementById("medvatamt-" + rowId).value =
        taxableamt.toFixed(2);
      document.getElementById("medamount-" + rowId).value =
        amounttot.toFixed(2);
    }
    this.getTotals();
    //  The batch rows under this line read it out of the DOM.
    this.refreshBatchRows(rowId);
    this.forceUpdate();
  };

  //caliculate dynamic values
  caliculateInvoiceAmountsNewRows = (id) => {
    let data = id;
    let rawData = data.split("-");
    let rowName = rawData[0];
    let rowId = rawData[1];
    let subTotal = 0;
    let totaldiscount = 0;
    let totalTaxableAmt = 0;
    let search = data.search("~");
    let mrp = "";
    let billedQty = "";
    let taxamount = "";
    let medvat = "";
    let medvatamt = "";
    let meddiscount = "";
    let medamount = "";
    let discountCaliculation = "";
    let availableQty = "0";

    if (search > 0) {
      let batchRow = rowName[0].split("#");
      let batchRowId = batchRow[0] + "#";
      meddiscount = document.getElementById(
        batchRowId + "new~meddiscount-" + rowId
      ).value;
      discountCaliculation =
        (document.getElementById("medmrp-" + rowId).value * meddiscount) / 100;
      mrp = document.getElementById(batchRowId + "new~medmrp-" + rowId).value;
      billedQty = document.getElementById(
        batchRowId + "new~medbqty-" + rowId
      ).value;
      taxamount = document.getElementById(
        batchRowId + "new~medtaxamt-" + rowId
      ).value;
      if (this.state.retailerDetails["gst_type"] == "GST") {
        medvat =
          parseFloat(
            document.getElementById(batchRowId + "new~medCGST-" + rowId).value
          ) +
          parseFloat(
            document.getElementById(batchRowId + "new~medSGST-" + rowId).value
          );
      } else {
        medvat = parseFloat(
          document.getElementById(batchRowId + "new~medIGST-" + rowId).value
        );
      }
      medvatamt = document.getElementById(
        batchRowId + "new~medvatamt-" + rowId
      ).value;
      medamount = document.getElementById(
        batchRowId + "new~medamount-" + rowId
      ).value;
      availableQty = document.getElementById(
        batchRowId + "new~medaqty-" + rowId
      ).value;
      if (parseInt(billedQty) > parseInt(availableQty)) {
        toast.error(
          "Billed Quantity should not greater than Available Quantity"
        );
        return false;
      }
    } else {
      meddiscount = document.getElementById("meddiscount-" + rowId).value;
      mrp = document.getElementById("medmrp-" + rowId).value;
      billedQty = document.getElementById("medbqty-" + rowId).value;
      taxamount = document.getElementById("medtaxamt-" + rowId).value;
      if (this.state.retailerDetails["gst_type"] == "GST") {
        medvat =
          parseFloat(document.getElementById("medCGST-" + rowId).value) +
          parseFloat(document.getElementById("medSGST-" + rowId).value);
      } else {
        medvat = parseFloat(document.getElementById("medIGST-" + rowId).value);
      }
      medvatamt = document.getElementById("medvatamt-" + rowId).value;
      medamount = document.getElementById("medamount-" + rowId).value;
      availableQty = document.getElementById("medaqty-" + rowId).value;
      if (parseInt(billedQty) > parseInt(availableQty)) {
        toast.error(
          "Billed Quantity should not greater than Available Quantity"
        );
        return false;
      }
    }

    let amt = mrp * billedQty;

    totaldiscount = parseFloat((amt * meddiscount) / 100);
    let netbill = parseFloat(amt) - parseFloat((amt * meddiscount) / 100);
    let taxableamt = parseFloat(netbill) / (1 + medvat / 100);
    let vatamount = parseFloat(netbill) - parseFloat(taxableamt);
    let amounttot = netbill;
    subTotal = parseFloat(subTotal) + parseFloat(netbill);

    this.state.totaldiscount = totaldiscount
      .toFixed(2)
      .replace(/\d(?=(\d{3})+\.)/g, "$&,");

    if (search > 0) {
      let batchRow = rowName[0].split("#");
      let batchRowId = batchRow[0] + "#";
      document.getElementById(batchRowId + "new~medtaxamt-" + rowId).value =
        vatamount.toFixed(2);
      document.getElementById(batchRowId + "new~medvatamt-" + rowId).value =
        taxableamt.toFixed(2);
      document.getElementById(batchRowId + "new~medamount-" + rowId).value =
        amounttot.toFixed(2);
    } else {
      document.getElementById("medtaxamt-" + rowId).value =
        vatamount.toFixed(2);
      document.getElementById("medvatamt-" + rowId).value =
        taxableamt.toFixed(2);
      document.getElementById("medamount-" + rowId).value =
        amounttot.toFixed(2);
    }
    this.getTotals();
    //  The batch rows under this line read it out of the DOM.
    this.refreshBatchRows(rowId);
    this.forceUpdate();
  };

  // get totals
  getTotals = () => {
    let total = 0;
    let discount = 0;
    let taxamt = 0;
    let vatamt = 0;
    let totalpaid = 0;
    let totalCoupanAmt = 0;
    let discamt = 0;
    let vatamts = 0;

    let totals = $(".amount_inp .form-control")
      .map(function () {
        return $(this).val();
      })
      .get();
    let taxamts = $(".tax_inp .form-control")
      .map(function () {
        return $(this).val();
      })
      .get();

    vatamts = $(".vatamt_inp .form-control")
      .map(function () {
        return $(this).val();
      })
      .get();

    let discamts = $(".disc_inp .form-control")
      .map(function () {
        return $(this).val();
      })
      .get();

    let mrpamts = $(".mrp_inp .form-control")
      .map(function () {
        return $(this).val();
      })
      .get();

    let billqty = $(".bqty_inp .form-control")
      .map(function () {
        return $(this).val();
      })
      .get();

    for (var i in totals) {
      total += parseFloat(totals[i].replace(",", ""));
    }
    for (var i in taxamts) {
      taxamt += parseFloat(taxamts[i].replace(",", ""));
    }
    for (var i in vatamts) {
      vatamt += parseFloat(vatamts[i]);
    }

    for (var i in discamts) {
      if (mrpamts[i] > 0 && billqty[i] > 0) {
        discamt +=
          parseFloat(mrpamts[i].replace(",", "")) *
          parseFloat(billqty[i].replace(",", "")) *
          parseFloat(discamts[i].replace(",", "") / 100);
      }
    }
    this.state.subTotal = parseFloat(total)
      .toFixed(2)
      .replace(/\d(?=(\d{3})+\.)/g, "$&,");

    totalCoupanAmt = parseFloat(this.state.couponDiscountAmount || 0);

    this.state.totalCoupanAmt = totalCoupanAmt
      .toFixed(2)
      .replace(/\d(?=(\d{3})+\.)/g, "$&,");

    const deliveryAmt = parseFloat(this.state.deliveryCharges || 0);
    totalpaid = Number(total) + deliveryAmt - totalCoupanAmt;
    this.state.totalpaid = totalpaid
      .toFixed(2)
      .replace(/\d(?=(\d{3})+\.)/g, "$&,");
    //  taxamt sums the "tax_inp" cells, which hold the TAX; vatamt sums the
    //  "vatamt_inp" cells, which hold the TAXABLE value. They were assigned the
    //  other way round, so an order was stored - and shown - with its taxable
    //  amount and its tax exchanged. These two fields go straight into the
    //  invoice payload as total_taxable_amount / total_taxes.
    let totalpaidAmnt = (this.state.totalTaxableAmount = vatamt
      .toFixed(2)
      .replace(/\d(?=(\d{3})+\.)/g, "$&,"));
    this.state.totalTaxes = taxamt
      .toFixed(2)
      .replace(/\d(?=(\d{3})+\.)/g, "$&,");
    this.state.totaldiscount = discamt
      .toFixed(2)
      .replace(/\d(?=(\d{3})+\.)/g, "$&,");
  };

  // Remove batch
  removeBatch = (id) => {
    let data = id.split("-");
    let dynamicadded = $("#medadded-" + data[1]).val();
    dynamicadded = Number(dynamicadded) - 1;
    $("#medadded-" + data[1]).val(dynamicadded);
    $("#new-" + data[1]).html("");
    let rowData = data[0].split("#");
    let rowDataId = rowData[0] + "#";
    if (document.getElementById(rowDataId + "new-" + data[1])) {
      var myobj = document.getElementById(rowDataId + "new-" + data[1]);
      myobj.remove();
    }
    this.getTotals();
    this.forceUpdate();
  };
  //  For get Batches
  getBatches = (id) => {
    if (document.getElementById(id).options.length > 2) {
      return;
    }
    let reatailerId = this.state.retailerId;
    let data = id;
    let rawData = data.split("-");
    let rowName = rawData[0];
    rowName = rowName + "-";
    let rowId = rawData[1];
    let retailerbatchList = "";
    let batcheCount = 0;
    Httpconfig.httptokenget(
      Constant.siteurl +
      "api/OM/retailerProduct/getBatchDetails/" +
      reatailerId +
      "/" +
      rowId
    )
      .then((response) => {
        if (response.data.status == 200) {
          batcheCount = Object.keys(
            response.data.data[0].retailer_stock_tbls
          ).length;

          if (batcheCount > 0) {
            const product = response.data.data[0];
            let batchList = product.retailer_stock_tbls.map((stockEntry) => {
              return (
                <option
                  class="batchselect"
                  id={product.id}
                  value={
                    stockEntry.batch +
                    "~" +
                    stockEntry.expiry_date +
                    "~" +
                    stockEntry.quantity +
                    "~" +
                    stockEntry.id +
                    "~" +
                    stockEntry.mrp +
                    "~" +
                    rowId +
                    "~" +
                    stockEntry.discount
                  }
                >
                  {stockEntry.batch}/
                  {stockEntry.expiry_date}
                </option>
              );
            });

            this.state.retailerbatchList = batchList;
            this.forceUpdate();
            this.showOrderdetailsInvoice(this.state.patientAddressId);
          }
        }
      })
      .catch((error) => {
        toast.error(error);
      });
  };

  // get the new batches for new rows
  getBatchesNewRows = (id) => {
    let reatailerId = this.state.retailerId;
    let data = id;
    let rawData = data.split("-");
    let rowName = rawData[0];
    let rowId = rawData[2];
    Httpconfig.httptokenget(
      Constant.siteurl +
      "api/OM/retailerProduct/getBatchDetails/" +
      reatailerId +
      "/" +
      rowId
    )
      .then((response) => {
        if (response.data.status == 200) {
          if (Object.keys(response.data.data).length > 0) {
            const product = response.data.data[0];
            const retailerbatchList = product.retailer_stock_tbls.map(
              (stockEntry) => {
                return (
                  <option
                    id={product.id}
                    value={
                      stockEntry.batch +
                      "/" +
                      stockEntry.expiry_date
                    }
                  >
                    {stockEntry.batch}/{stockEntry.expiry_date}
                  </option>
                );
              }
            );
            this.state.retailerbatchList = retailerbatchList;
            this.forceUpdate();
          }
        }
      })
      .catch((error) => {
        toast.error(error);
      });
  };
  //  For preview Invoice
  previewInvoice = () => {
    let productName = "";
    let manafacturer = "";
    let batchExpiry = "";
    let mrp = "";
    let oqty = "";
    let aqty = "";
    let bqty = "";
    let taxableAmount = "";
    let vat = "";
    let vatAmount = "";
    let discountAmount = "";
    var lineAmounts = "";
    let invoice = "";
    let invoiceData = "";
    let batch = "";
    let expiredate = "";
    let medicinestockid = "";
    let medicineId = "";
    let Invoicearray = [];
    let error = 0;

    $("#theTable > tbody >tr").each(function (row, tr) {
      //  The "+ Add batch" bar is a control row, not a line item.
      if ($(this).hasClass("no-invoice-row")) return;

      $(this)
        .find("td")
        .each(function () {
          let className = $(this).attr("class");

          if (className == "item_inp") {
            productName = $(this).text();
            manafacturer = "";
            let search = productName.search("<h6>");
            if (search > 0) {
              productName = productName
                .replace("</h6>", "")
                .replace("<h6>", "")
                .replace("&amp;", "&");
            }
          }

          if (className == "batch_inp") {
            batchExpiry = $(this).find("select").val();
            if (batchExpiry != "select batch" && batchExpiry) {
              batchExpiry = batchExpiry.split("~");
              batch = batchExpiry[0];
              expiredate = batchExpiry[1];
              medicinestockid = batchExpiry[3];
              medicineId = batchExpiry[5];
            } else {
              toast.error("Select batch for " + productName);
              error = error + 1;
            }
          }

          if (className == "mrp_inp") {
            mrp = $(this).find(".form-control").val();
          }

          if (className == "oqty_inp") {
            oqty = $(this).find(".form-control").val();
          }
          if (className == "aqty_inp") {
            aqty = $(this).find(".form-control").val();
          }
          if (className == "bqty_inp") {
            bqty = $(this).find(".form-control").val();
          }
          if (className == "tax_inp") {
            taxableAmount = $(this).find(".form-control").val();
          }
          if (className == "vat_inp") {
            vat = $(this).find(".form-control").val();
          }
          if (className == "vatamt_inp") {
            vatAmount = $(this).find(".form-control").val();
          }
          if (className == "disc_inp") {
            discountAmount = $(this).find(".form-control").val();
          }
          if (className == "amount_inp") {
            lineAmounts = $(this).find(".form-control").val();
          }
          if (className == "bqty_inp") {
            if (parseInt(bqty) > parseInt(aqty)) {
              toast.error(
                "Billed Quantity should not greater than Available Quantity"
              );
              error = error + 1;
            }
          }
        });
      invoiceData = {
        medicineId: medicineId,
        medicinestockid: medicinestockid,
        productName: productName,
        manafacturer: manafacturer,
        batchExpiry: batchExpiry,
        batch: batch,
        expiredate: expiredate,
        mrp: mrp,
        oqty: oqty,
        bqty: bqty,
        taxableAmount: taxableAmount,
        vat: vat,
        vatAmount: vatAmount,
        discountAmount: discountAmount,
        lineAmount: lineAmounts,
      };

      Invoicearray.push(invoiceData);
    });
    if (error > 0) {
      return false;
    }

    this.setState({
      showOrderDetailsProcess: "pharmacy-tab collapse-hide",
      showOrdersGrid: "row showorder-list collapse-hide",
      showRejectReasons: "collapse-hide",
      invoiceDiv: "collapse-hide",
      invoicePDFPreview: "collapse-show",
      invoiceRows: Invoicearray,
    });
  };
  //  For Show Invoice page
  showInvoicePage = () => {
    this.setState({
      showOrderDetailsProcess: "pharmacy-tab collapse-hide",
      showOrdersGrid: "row showorder-list collapse-hide",
      showRejectReasons: "collapse-hide",
      invoiceDiv: "collapse-show",
      invoicePDFPreview: "collapse-hide",
    });
  };

  //  Reasons offered in the request dialog. Kept in step with
  //  app/helpers/prescriptionReupload.js, which lists the same set.
  static reuploadReasons = [
    "Blurred / not readable",
    "Prescription has expired",
    "Prescription is for a different patient",
    "Doctor details or signature missing",
    "Ordered medicines are not on the prescription",
    "Wrong document uploaded",
  ];

  //  target is the prescription being rejected, or null to ask for a new
  //  prescription without pointing at one of the uploaded documents.
  openReuploadModal = (target) => {
    this.setState({
      reuploadModal: "collapse-show",
      reuploadTarget: target,
      reuploadReason: "",
      reuploadOtherReason: "",
    });
  };

  closeReuploadModal = () => {
    this.setState({
      reuploadModal: "collapse-hide",
      reuploadTarget: null,
      reuploadReason: "",
      reuploadOtherReason: "",
    });
  };

  //sending prescription request
  //  documents names the prescriptions the customer has to replace. Empty means
  //  an order-level request, which is what this did before it could be specific.
  sendPrescriptionReq = (documents, reason) => {
    const targetDocuments = Array.isArray(documents) ? documents.filter(Boolean) : [];
    const requestReason = reason || "";

    //  Look the labels up from the same list the panel is showing so the email
    //  and the toast agree on which prescription this is about.
    const labels = targetDocuments
      .map((url) => {
        const match = (this.state.orderPrescriptions || []).find((p) => p.url === url);
        return match ? match.label : "";
      })
      .filter(Boolean);

    const subject = labels.length ? labels.join(" and ") : "a new prescription";

    toast.success("Email Sending.....");
    let emailSub = "Prescription request";

    let messageBody = "";
    messageBody += "<p>Hello " + this.state.customerName + ",</p>";
    messageBody +=
      "<p>Pharmacy " + this.state.retailerName + " ask you a prescription</p>";
    messageBody +=
      "<p>We request you to please re-upload " +
      subject +
      " from the link below to help us process your order. for the Order Id: " +
      this.state.orderId +
      "</p><br><br>";
    messageBody +=
      "<a href='" +
      Constant.imgurl +
      "/myOrders'>" +
      Constant.imgurl +
      "/myOrders</a>";
    messageBody += "<p>Thanks,<br>Medleymed Team</p>";

    Httpconfig.httptokenpost(
      Constant.siteurl + "api/OM/orderProcess/sendPrescriptionReq",
      {
        customerEmail: this.state.custmerEmail,
        emailSub: emailSub,
        emailBody: messageBody,
        customermobile: this.state.customermobile,
        orderId: this.state.orderId,
        customerName: this.state.customerName,
        documents: targetDocuments,
        reason: requestReason,
      }
    )
      .then((response) => {
        if (response.data.status == 200) {
          toast.success(response.data.message);

          //  Reflect the request in the panel straight away, so the retailer can
          //  see what they have already asked for and does not send it twice.
          this.setState({
            orderPrescriptions: (this.state.orderPrescriptions || []).map((p) =>
              targetDocuments.indexOf(p.url) > -1
                ? { ...p, reupload_required: true, reason: requestReason }
                : p
            ),
            //  A request that names no document is order-level, and nothing in
            //  orderPrescriptions would show it.
            orderLevelReuploadPending: targetDocuments.length
              ? this.state.orderLevelReuploadPending
              : true,
          });
        }
      })
      .catch((error) => {
        toast.error(error);
      });

    this.closeReuploadModal();
  };

  //  One uploaded prescription, with the label the customer sees on the same
  //  document. Matching labels on both sides is what makes the request
  //  unambiguous, so the label comes from the API rather than being recomputed.
  renderPrescriptionCard = (prescription) => {
    const isPdf =
      typeof prescription.url === "string" && /\.pdf(\?|$)/i.test(prescription.url);
    const flagged = !!prescription.reupload_required;

    return (
      <div
        key={prescription.url || prescription.index}
        style={{
          display: "inline-block",
          verticalAlign: "top",
          marginRight: 10,
          marginBottom: 10,
          padding: 6,
          borderRadius: 6,
          border: flagged ? "2px solid #dc3545" : "1px solid #dee2e6",
          background: flagged ? "#fff5f5" : "#fff",
          width: 150,
        }}
      >
        <a
          href={prescription.url || "#"}
          target="_blank"
          rel="noopener noreferrer"
          title={isPdf ? "Click to open PDF" : prescription.label}
        >
          {isPdf ? (
            <div
              style={{
                width: 80,
                height: 80,
                display: "inline-flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                background: "#fff3f3",
                border: "2px solid #dc3545",
                borderRadius: 6,
                fontSize: 10,
                color: "#dc3545",
                fontWeight: "bold",
              }}
            >
              <span style={{ fontSize: 28, lineHeight: 1 }}>&#128196;</span>
              PDF
            </div>
          ) : (
            <img
              className="presc_img"
              src={prescription.url}
              alt={prescription.label}
              style={{ width: 80, height: 80, objectFit: "cover", borderRadius: 6 }}
            />
          )}
        </a>

        <p style={{ margin: "6px 0 2px", fontWeight: "bold", fontSize: 13 }}>
          {prescription.label}
        </p>

        {flagged ? (
          <p style={{ margin: 0, fontSize: 11, color: "#dc3545" }}>
            Re-upload requested
            {prescription.reason ? ": " + prescription.reason : ""}
          </p>
        ) : (
          <p
            style={{
              margin: 0,
              fontSize: 11,
              color: "#007bff",
              cursor: "pointer",
              textDecoration: "underline",
            }}
            onClick={() => this.openReuploadModal(prescription)}
          >
            Re-Upload Prescription
          </p>
        )}
      </div>
    );
  };

  //  Asking for a reason is the other half of the fix: the customer needs to
  //  know which prescription AND what was wrong with it, or they re-upload the
  //  same unusable file.
  renderReuploadModal = () => {
    const { reuploadTarget, reuploadReason, reuploadOtherReason } = this.state;
    const heading = reuploadTarget
      ? "Request a new " + reuploadTarget.label
      : "Request a new prescription";

    return (
      <div className={this.state.reuploadModal}>
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: "rgba(0,0,0,0.45)",
            zIndex: 1050,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <div
            style={{
              background: "#fff",
              borderRadius: 8,
              padding: 20,
              width: 420,
              maxWidth: "90%",
            }}
          >
            <h4 style={{ marginTop: 0, fontSize: 18 }}>{heading}</h4>
            <p style={{ fontSize: 13, color: "#555" }}>
              {reuploadTarget
                ? "The customer will be told to replace this specific prescription, and why."
                : "Use this when nothing has been uploaded yet, or none of the uploaded prescriptions can be used."}
            </p>

            <label style={{ fontSize: 13, fontWeight: "bold" }}>Reason</label>
            <select
              className="form-control"
              value={reuploadReason}
              onChange={(e) => this.setState({ reuploadReason: e.target.value })}
            >
              <option value="">-- Select a reason --</option>
              {Viewretailers.reuploadReasons.map((reason) => (
                <option key={reason} value={reason}>
                  {reason}
                </option>
              ))}
              <option value="Other">Other</option>
            </select>

            {reuploadReason === "Other" ? (
              <textarea
                className="form-control"
                style={{ marginTop: 10 }}
                rows="2"
                maxLength="255"
                placeholder="Tell the customer what is wrong with it"
                value={reuploadOtherReason}
                onChange={(e) =>
                  this.setState({ reuploadOtherReason: e.target.value })
                }
              />
            ) : (
              ""
            )}

            <div style={{ marginTop: 16, textAlign: "right" }}>
              <button
                className="btn btn-secondary"
                style={{ marginRight: 8 }}
                onClick={this.closeReuploadModal}
              >
                Cancel
              </button>
              <button
                className="btn btn-primary"
                onClick={this.submitReuploadRequest}
              >
                Send Request
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  };

  //  Submits the dialog. A reason is required: it is the whole point of the
  //  change - "please re-upload Prescription 2" without saying what is wrong
  //  with it still leaves the customer guessing.
  submitReuploadRequest = () => {
    const { reuploadReason, reuploadOtherReason, reuploadTarget } = this.state;
    const reason =
      reuploadReason === "Other" ? (reuploadOtherReason || "").trim() : reuploadReason;

    if (!reason) {
      toast.error("Please choose or type a reason");
      return;
    }

    this.sendPrescriptionReq(reuploadTarget ? [reuploadTarget.url] : [], reason);
  };

  processOrder = () => {
    let productName = "";
    let manafacturer = "";
    let batchExpiry = "";
    let mrp = "";
    let oqty = "";
    let aqty = "";
    let bqty = "";
    let taxableAmount = "";
    let cgst = 0;
    let sgst = 0;
    let igst = 0;
    let vatAmount = "";
    let discountAmount = "";
    var lineAmounts = "";
    let invoice = "";
    let invoiceData = "";
    let batch = "";
    let expiredate = "";
    let medicinestockid = "";
    let medicineId = "";
    let Invoicearray = [];
    let error = 0;
    let gstType = this.state.retailerDetails["gst_type"];
    let deliveryAgentCheckedCount = $(
      'input[name="deliveryAgent"]:checked'
    ).length;
    if (deliveryAgentCheckedCount == 0) {
      toast.error("Select Delivery Agent");
      return false;
    }

    $("#theTable > tbody >tr").each(function (row, tr) {
      //  The "+ Add batch" bar is a control row, not a line item.
      if ($(this).hasClass("no-invoice-row")) return;

      $(this)
        .find("td")
        .each(function () {
          let className = $(this).attr("class");

          if (className == "item_inp") {
            productName = $(this).text();
            manafacturer = "";
            let search = productName.search("<h6>");
            if (search > 0) {
              productName = productName
                .replace("</h6>", "")
                .replace("<h6>", "")
                .replace("&amp;", "&");
            }
          }



          if (className == "batch_inp") {
            batchExpiry = $(this).find("select").val();
            if (batchExpiry != "select batch" && batchExpiry != null) {
              batchExpiry = batchExpiry.split("~");
              batch = batchExpiry[0];
              expiredate = batchExpiry[1];
              medicinestockid = batchExpiry[3];
              medicineId = batchExpiry[5];
            } else {
              toast.error("Select batch for " + productName);
              error = error + 1;
            }
          }

          if (className == "mrp_inp") {
            mrp = $(this).find(".form-control").val();
          }

          if (className == "oqty_inp") {
            oqty = $(this).find(".form-control").val();
          }
          if (className == "aqty_inp") {
            aqty = $(this).find(".form-control").val();
          }
          if (className == "bqty_inp") {
            bqty = $(this).find(".form-control").val();
          }
          if (className == "tax_inp") {
            taxableAmount = $(this).find(".form-control").val();
          }
          if (gstType == "GST") {
            igst = 0;
            if (className == "cgst_inp") {
              cgst = $(this).find(".form-control").val();
            }
            if (className == "sgst_inp") {
              sgst = $(this).find(".form-control").val();
            }
          } else {
            cgst = 0;
            sgst = 0;
            if (className == "igst_inp") {
              igst = $(this).find(".form-control").val();
            }
          }

          if (className == "vatamt_inp") {
            vatAmount = $(this).find(".form-control").val();
          }
          if (className == "disc_inp") {
            discountAmount = $(this).find(".form-control").val();
          }
          if (className == "amount_inp") {
            lineAmounts = $(this).find(".form-control").val();
          }
          if (className == "bqty_inp") {
            if (parseInt(bqty) > parseInt(aqty)) {
              toast.error(
                "Billed Quantity should not greater than Available Quantity"
              );
              error = error + 1;
            }
          }
        });

      invoiceData = {
        medicineId: medicineId,
        medicinestockid: medicinestockid,
        productName: productName,
        manafacturer: manafacturer,
        batchExpiry: batchExpiry,
        batch: batch,
        expiredate: expiredate,
        mrp: mrp,
        oqty: oqty,
        bqty: bqty,
        taxableAmount: taxableAmount,
        CGST: cgst,
        SGST: sgst,
        IGST: igst,
        vatAmount: vatAmount,
        discountAmount: discountAmount,
        lineAmount: lineAmounts,
      };

      Invoicearray.push(invoiceData);
    });

    if (error > 0) {
      return false;
    }
    this.setState({ invoiceRows: Invoicearray });

    let invoice_details = [];
    let stk_details = [];
    Invoicearray.map((itemsdata, num) => {
      let inv_detail = {
        retailer_id: this.state.retailerId,
        order_id: this.state.orderId,
        patient_id: this.state.customerId,
        order_date: moment(this.state.orderDate).format("YYYY/MM/DD HH:mm:ss"),
        invoice_date: moment(this.state.invoiceDateTime).format(
          "YYYY-MM-DD HH:mm:ss"
        ),
        medicine_id: itemsdata.medicineId,
        batch: itemsdata.batch,
        expiry: itemsdata.expiredate,
        mrp: itemsdata.mrp.replace(",", ""),
        quantity: itemsdata.bqty,
        //  vatAmount is the "vatamt_inp" cell, which carries the taxable
        //  value. taxableAmount is read off "tax_inp" and is the TAX, so
        //  sending it here put the tax on the invoice line - and in the
        //  PDF - under the taxable rate.
        taxable_rate: (itemsdata.vatAmount || "0").replace(",", ""),
        CGST: itemsdata.CGST,
        SGST: itemsdata.SGST,
        IGST: itemsdata.IGST,
        discount: itemsdata.discountAmount.replace(",", ""),
        amount: itemsdata.lineAmount.replace(",", ""),
      };
      invoice_details.push(inv_detail);
    });
    Invoicearray.map((itemsdata, num) => {
      let stock_detail = {
        retailer_id: this.state.retailerId,
        order_id: this.state.orderId,
        patient_id: this.state.customerId,
        order_date: moment(this.state.orderDate).format("YYYY/MM/DD HH:mm:ss"),
        invoice_date: moment(this.state.invoiceDateTime).format(
          "YYYY-MM-DD HH:mm:ss"
        ),
        medicine_id: itemsdata.medicineId,
        batch: itemsdata.batch,
        expiry: itemsdata.expiredate,
        mrp: itemsdata.mrp.replace(",", ""),
        quantity: itemsdata.bqty,
        //  vatAmount is the "vatamt_inp" cell, which carries the taxable
        //  value. taxableAmount is read off "tax_inp" and is the TAX, so
        //  sending it here put the tax on the invoice line - and in the
        //  PDF - under the taxable rate.
        taxable_rate: (itemsdata.vatAmount || "0").replace(",", ""),
        CGST: itemsdata.CGST,
        SGST: itemsdata.SGST,
        IGST: itemsdata.IGST,
        discount: itemsdata.discountAmount.replace(",", ""),
        amount: itemsdata.lineAmount.replace(",", ""),
        id: itemsdata.medicinestockid,
      };
      stk_details.push(stock_detail);
    });
    let data = {
      retailer_id: this.state.retailerId,
      order_id: this.state.orderId,
      patient_id: this.state.customerId,
      order_date: moment(this.state.orderDate).format("YYYY/MM/DD HH:mm:ss"),
      invoice_date: moment(this.state.invoiceDateTime).format(
        "YYYY-MM-DD HH:mm:ss"
      ),
      payment_mode: this.state.payment_mode,
      total_taxable_amount: this.state.totalTaxableAmount,
      total_taxes: this.state.totalTaxes,
      sub_total: this.state.subTotal,
      discount: this.state.totaldiscount,
      total_paid: this.state.totalpaid,
      invoice_details: invoice_details,
      stock_details: stk_details,
      delivery_agent: this.state.deliveryAgent,
    };

    this.setState({ invoiceBtn: false });
    Httpconfig.httptokenpost(Constant.siteurl + "api/OM/orderInvoice/", data)
      .then((response) => {
        if (response.data.status == 200) {
          //  The server raises the invoice even when a batch turned out to be
          //  expired, or held less than was billed - refusing would strand a
          //  part-processed order - and reports it here instead of failing.
          //  Dropping these left stock written down to zero, or an expired
          //  batch dispensed, with nothing said to the retailer.
          const warnings = response.data.stock_warnings || [];
          if (warnings.length > 0) {
            toast.warn(
              "Invoice raised with " +
                warnings.length +
                " stock warning(s): " +
                warnings
                  .map((w) => (w.batch ? w.batch + " - " : "") + w.message)
                  .join("; "),
              { autoClose: 10000 }
            );
          }
          this.generatePDF();
        } else {
          //  A non-200 in the body still means nothing was raised, so the
          //  button has to come back or the order cannot be retried.
          this.setState({ invoiceBtn: true });
          toast.error(response.data.message || "Error generating invoice");
        }
      })
      .catch((error) => {
        //  A rejected allocation (422) names the offending line - wrong
        //  retailer, product not on this order, billed over the quantity
        //  ordered. Handing the Error object straight to toast rendered
        //  "[object Object]" and threw all of that away, leaving the retailer
        //  blocked with no idea which line was at fault.
        const body = (error && error.response && error.response.data) || null;
        const errors = (body && body.errors) || [];

        if (errors.length > 0) {
          toast.error(
            (body.message || "Batch allocation is not valid for this order") +
              ": " +
              errors
                .map((e) => (e.batch ? e.batch + " - " : "") + e.message)
                .join("; "),
            { autoClose: 12000 }
          );
        } else {
          toast.error(
            (body && body.message) ||
              (error && error.message) ||
              "Error generating invoice"
          );
        }

        //  Re-enable the button. It is switched off before the request and only
        //  back on once the PDF is made, so every failure above this left the
        //  retailer looking at a dead "Generate Invoice" until they reloaded -
        //  which matters more now that the message tells them what to fix.
        this.setState({ invoiceBtn: true });
      });
  };

  generatePDF = () => {
    let retailerId = this.state.retailerId;
    let orderId = this.state.orderId;
    let customerAddressId = this.state.customerAddressId;
    let timeZone = moment.tz.guess();

    Httpconfig.httptokenpost(
      Constant.siteurl +
      "api/OM/orderInvoice/generatePDF/" +
      retailerId +
      "/" +
      orderId,
      { timeZone: timeZone, customerAddressId }
    )
      .then((response) => {
        if (response.status == 200) {
          this.showgridpendingorders();
          $(".nav-item ,.nav-link").removeClass("active");
          $("#shipped_home-tab").addClass("show active");
          $("#shipped_home").addClass("show active");
          $("#processe_home").addClass("show active");
          $("#prescription_home").addClass("collapse-hide");

          this.retailerOrderDetails(this.state.retailerId, 3);
          this.setState({ invoiceBtn: true });
          const dispatch = response.data.dispatch;
          if (dispatch && dispatch.outcome === "created") {
            toast.success("Invoice generated and delivery task created");
          } else if (dispatch && dispatch.outcome === "failed") {
            toast.error(
              "Invoice generated, but delivery dispatch failed: " + dispatch.error
            );
          } else {
            toast.success("Invoice is generated successfully");
          }
          localStorage.setItem("pdfgenerate", 1);
          window.location.reload();
        }
      })
      .catch((error) => {
        toast.error(error);
      });
  };

  checkdelivery = (event) => {
    let id = event.currentTarget.id;
    if (id == "retailerAgent") {
      if ($("#" + id).is(":checked") == true)
        $("#Gokada").prop("checked", false);
    } else {
      if ($("#" + id).is(":checked") == true)
        $("#retailerAgent").prop("checked", false);
    }

    this.state.deliveryAgent = id;
  };

  render() {
    return (
      <main id="main">
        <RetailerHeader />
        <RetailerSideMenu />
        <section id="Pharmacy_dashboard">
          <div class="container-fluid">
            <div class="row">
              <div class="col-lg-10 col-md-10 Pharma_Content">
                <section id="pharm_tabs" class="pharmacy-tab">
                  <div class="container-fluid">
                    <div class="row">
                      <div class="col-lg-6 col-md-12 p_schedule ">
                        <DateRangeFilter
                          startDate={this.state.startDate}
                          endDate={this.state.endDate}
                          onStartDateChange={this.startDate.bind(this, "startDate")}
                          onEndDateChange={this.endDate.bind(this, "endDate")}
                          onFind={this.showOrderbyDates}
                          onClear={this.clearFilters}
                        />
                      </div>
                      <div class="col-lg-6 col-md-12">
                        <nav class="p_nav">
                          <div
                            class="nav nav-tabs nav-fill"
                            id="nav-tab"
                            role="tablist"
                          >
                            <a
                              class={this.state.currentHome}
                              id="current_home-tab"
                              data-toggle="tab"
                              href="#current_home"
                              role="tab"
                              aria-controls="current-home"
                              aria-selected="true"
                              onClick={this.handleClick}
                            >
                              Current<h6>(Pending)</h6>
                              <p>{this.state.pendingOrder}</p>
                            </a>
                            <a
                              class={this.state.prescriptionHome}
                              id="prescription_home-tab"
                              data-toggle="tab"
                              href="#prescription_home"
                              role="tab"
                              aria-controls="prescription-home"
                              aria-selected="true"
                              onClick={this.handleClick}
                            >
                              Prescription <h6>(Verified)</h6>
                              <p>{this.state.PrescriptionVerifiedOrder}</p>
                            </a>
                            <a
                              class={this.state.processedHome}
                              id="processed_home-tab"
                              data-toggle="tab"
                              href="#processed_home"
                              role="tab"
                              aria-controls="processed-home"
                              aria-selected="true"
                              onClick={this.handleClick}
                            >
                              Processed <h6>(Invoiced)</h6>
                              <p>{this.state.processingOrder}</p>
                            </a>
                            <a
                              class={this.state.shippedHome}
                              id="shipped_home-tab"
                              data-toggle="tab"
                              href="#shipped_home"
                              role="tab"
                              aria-controls="shipped-home"
                              aria-selected="true"
                              onClick={this.handleClick}
                            >
                              Shipped<h6>(Pending)</h6>
                              <p>{this.state.shippedOrder}</p>
                            </a>
                            <a
                              class={this.state.deliverHome}
                              id="deliver_home-tab"
                              data-toggle="tab"
                              href="#deliver_home"
                              role="tab"
                              aria-controls="deliver_home"
                              aria-selected="false"
                              onClick={this.handleClick}
                            >
                              Delivered<h6>(delivered 90%)</h6>
                              <p>{this.state.deliveredOrder}</p>
                            </a>
                            <a
                              class={this.state.cancelHome}
                              id="cancel_home-tab"
                              data-toggle="tab"
                              href="#cancel_home"
                              role="tab"
                              aria-controls="cancel_home"
                              aria-selected="false"
                              onClick={this.handleClick}
                            >
                              Cancelled <p>{this.state.cancelledOrder}</p>
                            </a>
                          </div>
                        </nav>
                      </div>
                    </div>
                    <div class={this.state.showOrdersGrid}>
                      <div class="col-md-12 no_padding">
                        <div class="tab-content" id="nav-tabContent">
                          <div
                            class={this.state.currentHomePanel}
                            id="current_home"
                            role="tabpanel"
                            aria-labelledby="current_home-tab"
                          >
                            <div class="tableFixHead">
                              <table>
                                <thead>
                                  <tr>
                                    <th>NO</th>
                                    <th>Customer</th>
                                    <th>Order ID</th>
                                    <th>Order Date & Time</th>
                                    <th>Prescription</th>
                                    <th>Items</th>
                                    <th>Amount</th>
                                    <th>Purchase Type</th>
                                    <th>Invoice</th>
                                    <th>Status</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {this.state.isLoading ? (
                                    <tr><td colSpan="10" style={{ textAlign: "center", padding: "20px" }}>Loading orders...</td></tr>
                                  ) : this.state.retailerFinalOrderMedicineDetailsView &&
                                    this.state.retailerFinalOrderMedicineDetailsView.length > 0 ? (
                                    this.state.retailerFinalOrderMedicineDetailsView
                                  ) : (
                                    <tr><td colSpan="10" style={{ textAlign: "center", padding: "20px" }}>No Orders</td></tr>
                                  )}
                                </tbody>
                              </table>
                            </div>
                          </div>
                          <div
                            class={this.state.prescriptionHomePanel}
                            id="prescription_home"
                            role="tabpanel"
                            aria-labelledby="prescription_home-tab"
                          >
                            <div class="tableFixHead">
                              <table>
                                <thead>
                                  <tr>
                                    <th>NO</th>
                                    <th>Customer</th>
                                    <th>Order ID</th>
                                    <th>Order Date</th>
                                    <th>Prescription</th>
                                    <th>Items</th>
                                    <th>Amount</th>
                                    <th>Purchase Type</th>
                                    <th>Invoice</th>
                                    <th>Status</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {this.state.isLoading ? (
                                    <tr><td colSpan="10" style={{ textAlign: "center", padding: "20px" }}>Loading orders...</td></tr>
                                  ) : this.state.retailerFinalOrderMedicineDetailsView &&
                                    this.state.retailerFinalOrderMedicineDetailsView.length > 0 ? (
                                    this.state.retailerFinalOrderMedicineDetailsView
                                  ) : (
                                    <tr><td colSpan="10" style={{ textAlign: "center", padding: "20px" }}>No Orders</td></tr>
                                  )}
                                </tbody>
                              </table>
                            </div>
                          </div>
                          <div
                            class={this.state.processedHomePanel}
                            id="processe_home"
                            role="tabpanel"
                            aria-labelledby="processed_home-tab"
                          >
                            <div class="tableFixHead">
                              <table>
                                <thead>
                                  <tr>
                                    <th>NO</th>
                                    <th>Customer</th>
                                    <th>Order ID</th>
                                    <th>Order Date</th>
                                    <th>Prescription</th>
                                    <th>Items</th>
                                    <th>Amount</th>
                                    <th>Purchase Type</th>
                                    <th>Invoice</th>
                                    <th>Status</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {this.state.isLoading ? (
                                    <tr><td colSpan="10" style={{ textAlign: "center", padding: "20px" }}>Loading orders...</td></tr>
                                  ) : this.state.retailerFinalOrderMedicineDetailsView &&
                                    this.state.retailerFinalOrderMedicineDetailsView.length > 0 ? (
                                    this.state.retailerFinalOrderMedicineDetailsView
                                  ) : (
                                    <tr><td colSpan="10" style={{ textAlign: "center", padding: "20px" }}>No Orders</td></tr>
                                  )}
                                </tbody>
                              </table>
                            </div>
                          </div>
                          <div
                            class={this.state.shippedHomePanel}
                            id="shipped_home"
                            role="tabpanel"
                            aria-labelledby="shipped_home-tab"
                          >
                            <div class="tableFixHead">
                              <table>
                                <thead>
                                  <tr>
                                    <th>NO</th>
                                    <th>Customer</th>
                                    <th>Order ID</th>
                                    <th>Order Date</th>
                                    <th>Prescription</th>
                                    <th>Items</th>
                                    <th>Amount</th>
                                    <th>Purchase Type</th>
                                    <th>Invoice</th>
                                    <th>Status</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {this.state.isLoading ? (
                                    <tr><td colSpan="10" style={{ textAlign: "center", padding: "20px" }}>Loading orders...</td></tr>
                                  ) : this.state.retailerFinalOrderMedicineDetailsView &&
                                    this.state.retailerFinalOrderMedicineDetailsView.length > 0 ? (
                                    this.state.retailerFinalOrderMedicineDetailsView
                                  ) : (
                                    <tr><td colSpan="10" style={{ textAlign: "center", padding: "20px" }}>No Orders</td></tr>
                                  )}
                                </tbody>
                              </table>
                            </div>
                          </div>
                          <div
                            class={this.state.deliverHomePanel}
                            id="deliver_home"
                            role="tabpanel"
                            aria-labelledby="deliver_home-tab"
                          >
                            <div class="tableFixHead">
                              <table>
                                <thead>
                                  <tr>
                                    <th>NO</th>
                                    <th>Customer</th>
                                    <th>Order ID</th>
                                    <th>Order Date</th>
                                    <th>Prescription</th>
                                    <th>Items</th>
                                    <th>Amount</th>
                                    <th>Purchase Type</th>
                                    <th>Invoice</th>
                                    <th>Status</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {this.state.isLoading ? (
                                    <tr><td colSpan="10" style={{ textAlign: "center", padding: "20px" }}>Loading orders...</td></tr>
                                  ) : this.state.retailerFinalOrderMedicineDetailsView &&
                                    this.state.retailerFinalOrderMedicineDetailsView.length > 0 ? (
                                    this.state.retailerFinalOrderMedicineDetailsView
                                  ) : (
                                    <tr><td colSpan="10" style={{ textAlign: "center", padding: "20px" }}>No Orders</td></tr>
                                  )}
                                </tbody>
                              </table>
                            </div>
                          </div>
                          <div
                            class={this.state.cancelHomePanel}
                            id="cancel_home"
                            role="tabpanel"
                            aria-labelledby="cancel_home-tab"
                          >
                            <div class="tableFixHead">
                              <table>
                                <thead>
                                  <tr>
                                    <th>NO</th>
                                    <th>Customer</th>
                                    <th>Order ID</th>
                                    <th>Order Date</th>
                                    <th>Prescription</th>
                                    <th>Items</th>
                                    <th>Amount</th>
                                    <th>Purchase Type</th>
                                    <th>Invoice</th>
                                    <th>Status</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {this.state.isLoading ? (
                                    <tr><td colSpan="10" style={{ textAlign: "center", padding: "20px" }}>Loading orders...</td></tr>
                                  ) : this.state.retailerFinalOrderMedicineDetailsView &&
                                    this.state.retailerFinalOrderMedicineDetailsView.length > 0 ? (
                                    this.state.retailerFinalOrderMedicineDetailsView
                                  ) : (
                                    <tr><td colSpan="10" style={{ textAlign: "center", padding: "20px" }}>No Orders</td></tr>
                                  )}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>

                <section
                  id="pharm_tabs"
                  class={this.state.showOrderDetailsProcess}
                >
                  <div class="container">
                    <div class="row">
                      <div class="col-md-12">
                        <div class="tab-content" id="nav-tabContent">
                          <div
                            class={this.state.currentHomePanel}
                            id="current_home"
                            role="tabpanel"
                            aria-labelledby="current_home-tab"
                          >
                            <div class="row">
                              <div class="col-md-4">
                                <div class="row">
                                  <div class="col-md-12">
                                    <a onClick={this.back}>
                                      {" "}
                                      <h2 class="order_back">
                                        <img src="../images/retailer/back_arrow.svg" />
                                        Back to Order's List
                                      </h2>
                                    </a>
                                  </div>
                                </div>
                                {this.state.requiresPrescription && (
                                <div class="Prescription_bar">
                                  <div class="presc_head">
                                    <h2>Prescription</h2>
                                  </div>
                                  {/*  The per-card red border says which
                                      prescription was flagged, but not that it
                                      blocks approval - this is the only place
                                      the retailer is told why Approve will not
                                      go through. */}
                                  {this.hasPendingReupload() ? (
                                    <div class="presc_reupload_pending">
                                      <strong>Waiting for re-upload.</strong>{" "}
                                      {this.pendingReuploads().length > 0
                                        ? this.pendingReuploads()
                                            .map((p) => p.label)
                                            .join(", ") +
                                          " " +
                                          (this.pendingReuploads().length > 1
                                            ? "have"
                                            : "has") +
                                          " not been replaced yet."
                                        : "The customer has not uploaded the requested prescription yet."}{" "}
                                      This order cannot be approved until the
                                      customer uploads the new prescription.
                                    </div>
                                  ) : null}
                                  {/*  Two routes to the same request is one
                                      too many. Once documents are on the
                                      order, the per-card "Request re-upload"
                                      link is the only correct one - it names
                                      the document the customer has to replace,
                                      and the replacement lands in that slot
                                      instead of being appended. The
                                      order-level button stays for the case it
                                      is actually for: nothing uploaded yet. */}
                                  {this.state.orderPrescriptions &&
                                    this.state.orderPrescriptions.length > 0 ? (
                                    <h6>
                                      To ask for a new copy, use the
                                      "Request re-upload" link on the
                                      prescription that needs replacing, so the
                                      customer is told which one it is.
                                    </h6>
                                  ) : (
                                    <React.Fragment>
                                      <a>
                                        {" "}
                                        <p
                                          class="send_rqst_btn"
                                          onClick={() =>
                                            this.openReuploadModal(null)
                                          }
                                        >
                                          Send Request
                                        </p>
                                      </a>
                                      <h6>
                                        Ask the customer for a prescription for
                                        this order.
                                      </h6>
                                    </React.Fragment>
                                  )}
                                  {/*  The per-document list needs the
                                      prescriptions field from the API. Falls
                                      back to the plain thumbnail strip so the
                                      panel still works against a server that
                                      predates it. */}
                                  {this.state.orderPrescriptions &&
                                    this.state.orderPrescriptions.length > 0 ? (
                                    <div class="prescription_img">
                                      {this.state.orderPrescriptions.map((p) =>
                                        this.renderPrescriptionCard(p)
                                      )}
                                    </div>
                                  ) : (
                                    <div class="prescription_img">
                                      {this.state.retailerPrescriptionDetailsView
                                        ? this.state
                                          .retailerPrescriptionDetailsView
                                        : "No Prescription Uploaded"}
                                    </div>
                                  )}
                                </div>
                                )}
                              </div>
                              <div class="col-md-8">
                                <div class="tableFixHead_Order">
                                  <table>
                                    <thead class="order_table">
                                      <tr>
                                        <th>
                                          {this.state.customerName}{" "}
                                          <h6> {this.state.customermobile}</h6>
                                        </th>
                                        <th>
                                          Order ID:{" "}
                                          <span>{this.state.orderId}</span>
                                        </th>
                                        <th>
                                          Items :
                                          <span>{this.state.itemsCount}</span>
                                        </th>
                                        <th>
                                          Price:{" "}
                                          <span>
                                            {Constant.currency}{" "}
                                            {this.state.amount}
                                          </span>
                                        </th>
                                      </tr>
                                    </thead>

                                    <tbody>{this.state.ordereditems}</tbody>
                                  </table>
                                  <div class="row pres_btns">
                                    <div class="col-md-6">
                                      <div class="rej_btn">
                                        <a onClick={this.rejectOrderShow}>
                                          <img src="../images/retailer/close_reject.svg" />
                                          Reject
                                        </a>
                                      </div>
                                    </div>
                                    <div class="col-md-6">
                                      <div
                                        class="app_btn"
                                        title={
                                          this.hasPendingReupload()
                                            ? "Waiting for the customer to re-upload the requested prescription"
                                            : ""
                                        }
                                      >
                                        <a
                                          name={this.state.customerAddressId}
                                          onClick={this.orderApprove}
                                          style={
                                            this.hasPendingReupload()
                                              ? { opacity: 0.5, cursor: "not-allowed" }
                                              : {}
                                          }
                                        >
                                          <img src="../images/retailer/tick_approved.svg" />
                                          Approve
                                        </a>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            class={this.state.deliverHomePanel}
                            id="deliver_home"
                            role="tabpanel"
                            aria-labelledby="deliver_home-tab"
                          >
                            <div class="tableFixHead">
                              <table>
                                <thead class="order_table">
                                  <tr>
                                    <th>NO</th>
                                    <th>Customer</th>
                                    <th>Order ID</th>
                                    <th>Order Date</th>
                                    <th>Prescription</th>
                                    <th>Items</th>
                                    <th>Amount</th>
                                    <th>Invoice</th>
                                    <th>Status</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <td>1</td>
                                    <td>
                                      John <h6>9876542587</h6>
                                    </td>
                                    <td>0070859</td>
                                    <td>20-05-2020</td>
                                    <td>
                                      <img
                                        class="presc_img"
                                        src="../images/retailer/RxFile.svg"
                                      />
                                      <img
                                        class="presc_img"
                                        src="../images/retailer/RxFile.svg"
                                      />
                                    </td>
                                    <td>8</td>
                                    <td>{Constant.currency} 890</td>
                                    <td class="pending_td">Delivered </td>
                                  </tr>
                                  <tr>
                                    <td>2</td>
                                    <td>
                                      John <h6>9876542587</h6>
                                    </td>
                                    <td>0070859</td>
                                    <td>20-05-2020</td>
                                    <td>
                                      <img
                                        class="presc_img"
                                        src="../images/retailer/RxFile.svg"
                                      />
                                      <img
                                        class="presc_img"
                                        src="../images/retailer/RxFile.svg"
                                      />
                                    </td>
                                    <td>8</td>
                                    <td>{Constant.currency} 890</td>
                                    <td class="pending_td">Delivered </td>
                                  </tr>
                                  <tr>
                                    <td>3</td>
                                    <td>
                                      John <h6>9876542587</h6>
                                    </td>
                                    <td>0070859</td>
                                    <td>20-05-2020</td>
                                    <td>
                                      <img
                                        class="presc_img"
                                        src="../images/retailer/RxFile.svg"
                                      />
                                      <img
                                        class="presc_img"
                                        src="../images/retailer/RxFile.svg"
                                      />
                                    </td>
                                    <td>8</td>
                                    <td>{Constant.currency} 890</td>
                                    <td class="pending_td">Delivered </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                          <div
                            class={this.state.cancelHomePanel}
                            id="cancel_home"
                            role="tabpanel"
                            aria-labelledby="cancel_home-tab"
                          >
                            <div class="tableFixHead">
                              <table>
                                <thead class="order_table">
                                  <tr>
                                    <th></th>
                                    <th>Customer</th>
                                    <th>Order ID</th>
                                    <th>Order Date</th>
                                    <th>Prescription</th>
                                    <th>Items</th>
                                    <th>Amount</th>
                                    <th>Status</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <td>1</td>
                                    <td>
                                      John <h6>9876542587</h6>
                                    </td>
                                    <td>0070859</td>
                                    <td>20-05-2020</td>
                                    <td>
                                      <img
                                        class="presc_img"
                                        src="../images/retailer/RxFile.svg"
                                      />
                                      <img
                                        class="presc_img"
                                        src="../images/retailer/RxFile.svg"
                                      />
                                    </td>
                                    <td>8</td>
                                    <td>{Constant.currency} 890</td>
                                    <td class="pending_td">Cancelled </td>
                                  </tr>
                                  <tr>
                                    <td>2</td>
                                    <td>
                                      John <h6>9876542587</h6>
                                    </td>
                                    <td>0070859</td>
                                    <td>20-05-2020</td>
                                    <td>
                                      <img
                                        class="presc_img"
                                        src="../images/retailer/RxFile.svg"
                                      />
                                      <img
                                        class="presc_img"
                                        src="../images/retailer/RxFile.svg"
                                      />
                                    </td>
                                    <td>8</td>
                                    <td>{Constant.currency} 890</td>
                                    <td class="pending_td">Cancelled </td>
                                  </tr>
                                  <tr>
                                    <td>3</td>
                                    <td>
                                      John <h6>9876542587</h6>
                                    </td>
                                    <td>0070859</td>
                                    <td>20-05-2020</td>
                                    <td>
                                      <img
                                        class="presc_img"
                                        src="../images/retailer/RxFile.svg"
                                      />
                                      <img
                                        class="presc_img"
                                        src="../images/retailer/RxFile.svg"
                                      />
                                    </td>
                                    <td>8</td>
                                    <td>{Constant.currency} 890</td>
                                    <td class="pending_td">Cancelled </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>

                <section
                  id="reject_reason"
                  class={this.state.showRejectReasons}
                >
                  <div class="container">
                    <div class="row">
                      <div class="col-md-8">
                        <div class="reject_back">
                          <a onClick={this.back}>
                            {" "}
                            <h2>
                              <img src="../images/patient/img/arrow-back.svg" />
                              Back to Order's List
                            </h2>
                          </a>
                        </div>
                        <div class="reject_head">
                          <h2>
                            <img
                              src="../images/patient/img/arrow-back.svg"
                              onClick={this.hidegridpendingorders}
                            />
                          </h2>
                        </div>
                        <div class="reject_content">
                          <div class="rej_main">
                            <h2>Reasons For the rejection</h2>
                            {this.state.retailerRejectList
                              ? this.state.retailerRejectList
                              : "no"}
                          </div>
                        </div>
                        <div class="reject_bottom">
                          <div class="submit_btn">
                            <button type="button" onClick={this.rejectOrder}>
                              Submit
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>

                <section id="retailer_invoice" class={this.state.invoiceDiv}>
                  <div class="container">
                    <div class="row">
                      <div class="col-md-12">
                        <div class="ret_inv_section">
                          <div class="ret_inv_head">
                            <h2>
                              <h6 class="ret_inv_back">
                                {" "}
                                <a onClick={this.showgridpendingorders}>
                                  <img src="../images/retailer/back_arrow.svg" />
                                  Back to Order's List
                                </a>{" "}
                              </h6>{" "}
                              Invoice
                            </h2>
                          </div>
                          <div class="ret_pharm_det">
                            <div class="row">
                              <div class="col-md-8">
                                <div class="pharm_add">
                                  <h2>{this.state.storeName}</h2>
                                  <h5>{this.state.storeAddress}</h5>
                                </div>
                              </div>
                              <div class="col-md-4">
                                <div class="pharm_order">
                                  <p>
                                    Order No: <span>{this.state.orderId}</span>
                                  </p>
                                  <p>
                                    Order Date :{" "}
                                    <span>
                                      {dateformatter.asianDateFormat(
                                        this.state.orderDate
                                      )}
                                    </span>
                                  </p>
                                  <p>
                                    Invoice Date:{" "}
                                    <span>
                                      {dateformatter.asianDateFormat(
                                        this.state.invoiceDateTime
                                      )}
                                    </span>
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="ret_invoice_table">
                            <div class="tab-pane">
                              <div class="tableFixHead">
                                <table
                                  class="table table-bordered"
                                  id="theTable"
                                >
                                  <thead>
                                    <tr>
                                      <th>Sl.no</th>
                                      <th>Product</th>
                                      <th>Batch & Expiry</th>
                                      <th>O Qty</th>
                                      <th>A Qty</th>
                                      <th>B Qty</th>
                                      {this.state.retailerDetails["gst_type"] ==
                                        "GST" ? (
                                        <th>GST (SGST+CGST)</th>
                                      ) : (
                                        <th>IGST %</th>
                                      )}
                                      {this.state.retailerDetails["gst_type"] ==
                                        "GST" ? (
                                        <React.Fragment>
                                          <th>CGST %</th>
                                          <th>SGST %</th>
                                        </React.Fragment>
                                      ) : (
                                        <th>IGST Amt</th>
                                      )}

                                      <th>Taxable Amt {Constant.currency}</th>
                                      <th>
                                        MRP
                                        {Constant.currency}
                                      </th>
                                      <th>Discount %</th>
                                      <th>Amount {Constant.currency}</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {
                                      this.state
                                        .retailerOrderMedicineInvoiceDetailsView
                                    }

                                    <div
                                      id="newRow"
                                      style={{ display: "none" }}
                                    >
                                      {this.state.newRow}
                                    </div>
                                  </tbody>
                                </table>
                              </div>
                            </div>

                            <div class="ret_inv_footer">
                              <div class="row">
                                <div class="col-md-12 amount__right">
                                  <div class="total_tax">
                                    {/*  <h5>
                                      Total Taxes :{" "}
                                      <span>
                                        {Constant.currency}{" "}
                                        {this.state.totalTaxableAmount}
                                      </span>
                                    </h5>
                                    <h5>
                                      Total Taxable Amount :{" "}
                                      <span>
                                        {Constant.currency}{" "}
                                        {this.state.totalTaxes}
                                      </span>
                                    </h5>  */}
                                  </div>
                                  <div class="total_amnt">
                                    <p>
                                      Sub Total :{" "}
                                      <span>
                                        {Constant.currency}{" "}
                                        {this.state.subTotal}
                                      </span>
                                    </p>
                                    <p>
                                      Discounted Price :{" "}
                                      <span>
                                        {" "}
                                        {Constant.currency}{" "}
                                        {this.state.totaldiscount}
                                      </span>
                                    </p>
                                    <p>
                                      Coupon Discount
                                      <span>
                                        {" "}
                                        : {Constant.currency}{" "}
                                        {this.state.totalCoupanAmt
                                          ? this.state.totalCoupanAmt
                                          : "0.00"}
                                      </span>
                                    </p>
                                    <p>
                                      Delivery Charges :{" "}
                                      <span>
                                        {" "}
                                        {Constant.currency}{" "}
                                        {parseFloat(this.state.deliveryCharges || 0)
                                          .toFixed(2)
                                          .replace(/\d(?=(\d{3})+\.)/g, "$&,")}
                                      </span>
                                    </p>
                                    <h3>
                                      Total Paid :{" "}
                                      <span>
                                        {Constant.currency}{" "}
                                        {parseFloat(this.state.totalpaid)
                                          .toFixed(2)
                                          .replace(/\d(?=(\d{3})+\.)/g, "$&,")}
                                      </span>
                                    </h3>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="ret_inv_pay">
                              <div class="row">
                                <div class="col-md-4">
                                  <div class="payment_mode">
                                    <p>
                                      Payment mode:{" "}
                                      <span>
                                        {this.state.payment_mode
                                          ? this.state.payment_mode
                                          : "Online"}
                                      </span>
                                    </p>
                                    <p>
                                      Delivery Address :{" "}
                                      <span>{this.state.customerName}</span>
                                      <span>{this.state.customerAddress2}</span>
                                      <span>{this.state.customerLandmark}</span>
                                      <span>{this.state.zipcode}</span>
                                      <span>
                                        Mobile:{this.state.customermobile}
                                      </span>
                                    </p>
                                  </div>
                                </div>
                                <div class="col-md-4">
                                  <div class="delivery_agent">
                                    <h2>Select your Delivery agent</h2>
                                    {/* {this.state.deliverymode} */}
                                    <p>

                                      <input
                                        type="checkbox"
                                        name="deliveryAgent"
                                        id="retailerAgent"
                                        onChange={this.checkdelivery}
                                      />{" "}
                                      {this.state.deliverymode == 'third party' ? this.state.deliverymode : "Pharmacy Agent"}
                                      {/* Pharmacy Agent */}
                                    </p>
                                  </div>
                                </div>
                                <div class="col-md-4">
                                  <div class="ret_inv_btns">
                                    <a>
                                      {" "}
                                      <p
                                        class="preview_btn"
                                        onClick={this.previewInvoice}
                                      >
                                        Preview
                                      </p>
                                    </a>
                                    {this.state.invoiceBtn ? (
                                      <a id="disable-invoice-btn">
                                        {" "}
                                        <p
                                          class="processs_btn"
                                          onClick={this.processOrder.bind(this)}
                                        >
                                          Generate Invoice
                                        </p>
                                      </a>
                                    ) : (
                                      <a id="disable-invoice-btn">
                                        {" "}
                                        <p class="processs_btn">
                                          Generate Invoice
                                        </p>
                                      </a>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>

                <section id="invoicepdf" class={this.state.invoicePDFPreview}>
                  <div class="container">
                    <div class="row">
                      <div class="col-md-12">
                        <a onClick={this.showInvoicePage}>
                          {" "}
                          <h2 class="order_back">
                            <img src="../images/patient/img/arrow-back.svg" />
                            Back to Order's List
                          </h2>
                        </a>
                      </div>
                    </div>

                    <div style={{ margin: "10px", display: "block" }}>
                      <div>
                        <h2
                          style={{
                            fontSize: "22px",
                            margin: "5px 0px",
                            color: "#000",
                            fontFamily: "sans-serif",
                          }}
                        >
                          {this.state.storeName}
                        </h2>
                      </div>
                      <div
                        style={{
                          margin: "10px 0px",
                          display: "inline-block",
                          width: "100%",
                        }}
                      >
                        <div style={{ width: "50%", float: "left" }}>
                          <h4
                            style={{
                              letterSpacing: "0px",
                              color: "#000000",
                              fontSize: "16px",
                              margin: "5px 0px",
                              opacity: 1,
                              fontFamily: "sans-serif",
                              fontWeight: 600,
                              display: "inline-block",
                              marginRight: "20px",
                            }}
                          >
                            Invoice number :{" "}
                            <span
                              style={{
                                fontWeight: 300,
                                fontSize: "15px",
                                color: "#212121",
                                fontFamily: "sans-serif",
                                letterSpacing: "0px",
                                opacity: 1,
                              }}
                            >
                              5842158
                            </span>{" "}
                          </h4>
                          <h4
                            style={{
                              letterSpacing: "0px",
                              color: "#000000",
                              fontSize: "16px",
                              margin: "5px 0px",
                              opacity: 1,
                              fontFamily: "sans-serif",
                              fontWeight: 600,
                              display: "inline-block",
                              marginRight: "20px",
                            }}
                          >
                            DL number :{" "}
                            <span
                              style={{
                                fontWeight: 300,
                                fontSize: "15px",
                                color: "#212121",
                                fontFamily: "sans-serif",
                                letterSpacing: "0px",
                                opacity: 1,
                              }}
                            >
                              5842158AB6
                            </span>{" "}
                          </h4>
                          <p
                            style={{
                              letterSpacing: "0px",
                              color: "#000000",
                              fontSize: "15px",
                              margin: "5px 0px",
                              opacity: 1,
                              fontFamily: "sans-serif",
                              fontWeight: 300,
                              lineHeight: "22px",
                            }}
                          >
                            {this.state.storeAddress}
                          </p>
                        </div>
                        <div
                          style={{
                            float: "right",
                            width: "50%",
                            textAlign: "right",
                          }}
                        >
                          <p
                            style={{
                              letterSpacing: "0px",
                              color: "#000000",
                              fontSize: "15px",
                              margin: "2px 0px",
                              opacity: 1,
                              fontFamily: "sans-serif",
                              fontWeight: 300,
                              lineHeight: "22px",
                            }}
                          >
                            Order NO: <span>{this.state.orderId}</span>
                          </p>
                          <p
                            style={{
                              letterSpacing: "0px",
                              color: "#000000",
                              fontSize: "15px",
                              margin: "2px 0px",
                              opacity: 1,
                              fontFamily: "sans-serif",
                              fontWeight: 300,
                              lineHeight: "22px",
                            }}
                          >
                            Order Date:{" "}
                            <span>
                              {dateformatter.asianDateFormat(
                                this.state.orderDate
                              )}
                            </span>
                          </p>
                          <p
                            style={{
                              letterSpacing: "0px",
                              color: "#000000",
                              fontSize: "15px",
                              margin: "2px 0px",
                              opacity: 1,
                              fontFamily: "sans-serif",
                              fontWeight: 300,
                              lineHeight: "22px",
                            }}
                          >
                            Invoice Date:{" "}
                            <span>{this.state.invoiceDateTime}</span>
                          </p>
                        </div>
                      </div>
                      <div style={{ margin: "10px 0px 0px 0px" }}>
                        <div
                          className="table-responsive"
                          style={{
                            display: "block",
                            width: "100%",
                            overflowX: "auto",
                          }}
                        >
                          <table
                            className="table "
                            style={{
                              width: "100%",
                              marginBottom: "0px",
                              borderCollapse: "collapse",
                              backgroundColor: "transparent",
                              border: "1px solid #ddd",
                            }}
                          >
                            <thead
                              style={{
                                background: "#3b3e82 0% 0% no-repeat padding-box",
                                opacity: 1,
                              }}
                            >
                              <tr>
                                <th
                                  style={{
                                    borderBottom: "none",
                                    padding: "14px 10px",
                                    color: "#fff",
                                    border: "1px solid #ddd",
                                    fontSize: "15px",
                                    fontWeight: 600,
                                    fontFamily: "sans-serif",
                                    textAlign: "left",
                                  }}
                                >
                                  Sl.NO
                                </th>
                                <th
                                  style={{
                                    borderBottom: "none",
                                    padding: "14px 10px",
                                    color: "#fff",
                                    border: "1px solid #ddd",
                                    fontSize: "15px",
                                    fontWeight: 600,
                                    fontFamily: "sans-serif",
                                    textAlign: "left",
                                  }}
                                >
                                  Product
                                </th>
                                <th
                                  style={{
                                    borderBottom: "none",
                                    padding: "14px 10px",
                                    color: "#fff",
                                    border: "1px solid #ddd",
                                    fontSize: "15px",
                                    fontWeight: 600,
                                    fontFamily: "sans-serif",
                                    textAlign: "left",
                                  }}
                                >
                                  Batch &amp; Expiry
                                </th>
                                <th
                                  style={{
                                    borderBottom: "none",
                                    padding: "14px 10px",
                                    color: "#fff",
                                    border: "1px solid #ddd",
                                    fontSize: "15px",
                                    fontWeight: 600,
                                    fontFamily: "sans-serif",
                                    textAlign: "left",
                                  }}
                                >
                                  MRP
                                </th>
                                <th
                                  style={{
                                    borderBottom: "none",
                                    padding: "14px 10px",
                                    color: "#fff",
                                    border: "1px solid #ddd",
                                    fontSize: "15px",
                                    fontWeight: 600,
                                    fontFamily: "sans-serif",
                                    textAlign: "left",
                                  }}
                                >
                                  Qty.
                                </th>

                                {this.state.retailerDetails["gst_type"] ==
                                  "GST" ? (
                                  <React.Fragment>
                                    <th
                                      style={{
                                        borderBottom: "none",
                                        padding: "14px 10px",
                                        color: "#fff",
                                        border: "1px solid #ddd",
                                        fontSize: "15px",
                                        fontWeight: 600,
                                        fontFamily: "sans-serif",
                                        textAlign: "left",
                                      }}
                                    >
                                      CGST %
                                    </th>
                                    <th
                                      style={{
                                        borderBottom: "none",
                                        padding: "14px 10px",
                                        color: "#fff",
                                        border: "1px solid #ddd",
                                        fontSize: "15px",
                                        fontWeight: 600,
                                        fontFamily: "sans-serif",
                                        textAlign: "left",
                                      }}
                                    >
                                      SGST %
                                    </th>
                                  </React.Fragment>
                                ) : (
                                  <th
                                    style={{
                                      borderBottom: "none",
                                      padding: "14px 10px",
                                      color: "#fff",
                                      border: "1px solid #ddd",
                                      fontSize: "15px",
                                      fontWeight: 600,
                                      fontFamily: "sans-serif",
                                      textAlign: "left",
                                    }}
                                  >
                                    IGST %
                                  </th>
                                )}
                                {this.state.retailerDetails["gst_type"] ==
                                  "GST" ? (
                                  <th
                                    style={{
                                      borderBottom: "none",
                                      padding: "14px 10px",
                                      color: "#fff",
                                      border: "1px solid #ddd",
                                      fontSize: "15px",
                                      fontWeight: 600,
                                      fontFamily: "sans-serif",
                                      textAlign: "left",
                                    }}
                                  >
                                    GST Amt.
                                  </th>
                                ) : (
                                  <th
                                    style={{
                                      borderBottom: "none",
                                      padding: "14px 10px",
                                      color: "#fff",
                                      border: "1px solid #ddd",
                                      fontSize: "15px",
                                      fontWeight: 600,
                                      fontFamily: "sans-serif",
                                      textAlign: "left",
                                    }}
                                  >
                                    IGST Amt.
                                  </th>
                                )}

                                <th
                                  style={{
                                    borderBottom: "none",
                                    padding: "14px 10px",
                                    color: "#fff",
                                    border: "1px solid #ddd",
                                    fontSize: "15px",
                                    fontWeight: 600,
                                    fontFamily: "sans-serif",
                                    textAlign: "left",
                                  }}
                                >
                                  Discount %
                                </th>
                                <th
                                  style={{
                                    borderBottom: "none",
                                    padding: "14px 10px",
                                    color: "#fff",
                                    border: "1px solid #ddd",
                                    fontSize: "15px",
                                    fontWeight: 600,
                                    fontFamily: "sans-serif",
                                    textAlign: "left",
                                  }}
                                >
                                  Total Amt.
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {this.state.invoiceRows
                                ? this.state.invoiceRows.map((itemsdata, num) => (
                                  <tr>
                                    <td
                                      style={{
                                        padding: "10px",
                                        fontSize: "15px",
                                        fontFamily: "sans-serif",
                                        color: "#000",
                                        fontWeight: 600,
                                        letterSpacing: "0px",
                                        border: "1px solid #ddd",
                                      }}
                                    >
                                      {num + 1}
                                    </td>
                                    <td
                                      style={{
                                        padding: "14px 10px",
                                        fontSize: "15px",
                                        fontFamily: "sans-serif",
                                        color: "#000",
                                        fontWeight: 600,
                                        letterSpacing: "0px",
                                        border: "1px solid #ddd",
                                      }}
                                    >
                                      {itemsdata.productName}
                                      <p
                                        style={{
                                          fontSize: "15px",
                                          fontFamily: "sans-serif",
                                          color: "#000",
                                          fontWeight: 500,
                                          letterSpacing: "0px",
                                          margin: "5px 0px 0px 0px",
                                        }}
                                      >
                                        {itemsdata.manafacturer}
                                      </p>
                                    </td>
                                    <td
                                      style={{
                                        padding: "10px",
                                        fontSize: "15px",
                                        fontFamily: "sans-serif",
                                        color: "#000",
                                        fontWeight: 500,
                                        letterSpacing: "0px",
                                        border: "1px solid #ddd",
                                      }}
                                    >
                                      {itemsdata.batch}/{itemsdata.expiredate}
                                    </td>
                                    <td
                                      style={{
                                        padding: "10px",
                                        fontSize: "15px",
                                        fontFamily: "sans-serif",
                                        color: "#000",
                                        fontWeight: 500,
                                        letterSpacing: "0px",
                                        border: "1px solid #ddd",
                                      }}
                                    >
                                      {Constant.currency} {itemsdata.mrp}
                                    </td>
                                    <td
                                      style={{
                                        padding: "10px",
                                        fontSize: "15px",
                                        fontFamily: "sans-serif",
                                        color: "#000",
                                        fontWeight: 500,
                                        letterSpacing: "0px",
                                        border: "1px solid #ddd",
                                      }}
                                    >
                                      {itemsdata.oqty}
                                    </td>

                                    {this.state.retailerDetails["gst_type"] ==
                                      "GST" ? (
                                      <React.Fragment>
                                        <td
                                          style={{
                                            padding: "10px",
                                            fontSize: "15px",
                                            fontFamily: "sans-serif",
                                            color: "#000",
                                            fontWeight: 500,
                                            letterSpacing: "0px",
                                            border: "1px solid #ddd",
                                          }}
                                        >
                                          {itemsdata.discountAmount / 2}
                                        </td>{" "}
                                        <td
                                          style={{
                                            padding: "10px",
                                            fontSize: "15px",
                                            fontFamily: "sans-serif",
                                            color: "#000",
                                            fontWeight: 500,
                                            letterSpacing: "0px",
                                            border: "1px solid #ddd",
                                          }}
                                        >
                                          {itemsdata.discountAmount / 2}
                                        </td>
                                      </React.Fragment>
                                    ) : (
                                      <td
                                        style={{
                                          padding: "10px",
                                          fontSize: "15px",
                                          fontFamily: "sans-serif",
                                          color: "#000",
                                          fontWeight: 500,
                                          letterSpacing: "0px",
                                          border: "1px solid #ddd",
                                        }}
                                      >
                                        {itemsdata.discountAmount}
                                      </td>
                                    )}
                                    <td
                                      style={{
                                        padding: "10px",
                                        fontSize: "15px",
                                        fontFamily: "sans-serif",
                                        color: "#000",
                                        fontWeight: 500,
                                        letterSpacing: "0px",
                                        border: "1px solid #ddd",
                                      }}
                                    >
                                      {Constant.currency}{" "}
                                      {itemsdata.taxableAmount}
                                    </td>
                                    <td
                                      style={{
                                        padding: "10px",
                                        fontSize: "15px",
                                        fontFamily: "sans-serif",
                                        color: "#000",
                                        fontWeight: 500,
                                        letterSpacing: "0px",
                                        border: "1px solid #ddd",
                                      }}
                                    >
                                      {itemsdata.discountAmount}
                                    </td>
                                    <td
                                      style={{
                                        padding: "10px",
                                        fontSize: "15px",
                                        fontFamily: "sans-serif",
                                        color: "#000",
                                        fontWeight: 500,
                                        letterSpacing: "0px",
                                        border: "1px solid #ddd",
                                      }}
                                    >
                                      {Constant.currency} {itemsdata.lineAmount}
                                    </td>
                                  </tr>
                                ))
                                : ""}
                            </tbody>
                          </table>
                        </div>
                      </div>
                      <div style={{ margin: "10px 0px", float: "right" }}>
                        <div
                          style={{
                            display: "inline-block",
                            verticalAlign: "top",
                            marginRight: "25px",
                          }}
                        >
                          <p
                            style={{
                              letterSpacing: "0px",
                              color: "#000000",
                              fontSize: "15px",
                              fontWeight: 500,
                              margin: "10px 0px",
                              opacity: 1,
                              fontFamily: "sans-serif",
                            }}
                          >
                            Total Taxes:{" "}
                            <span>
                              {Constant.currency} {this.state.totalTaxableAmount}
                            </span>
                          </p>
                          <p
                            style={{
                              letterSpacing: "0px",
                              color: "#000000",
                              fontSize: "15px",
                              fontWeight: 500,
                              margin: "10px 0px",
                              opacity: 1,
                              fontFamily: "sans-serif",
                            }}
                          >
                            Total Taxable Amount:{" "}
                            <span>
                              {Constant.currency} {this.state.totalTaxes}
                            </span>
                          </p>
                        </div>
                        <div
                          style={{
                            display: "inline-block",
                            verticalAlign: "top",
                          }}
                        >
                          <p
                            style={{
                              letterSpacing: "0px",
                              color: "#000000",
                              fontSize: "15px",
                              fontWeight: 500,
                              margin: "10px 0px",
                              opacity: 1,
                              fontFamily: "sans-serif",
                            }}
                          >
                            Sub Total :{" "}
                            <span>
                              {Constant.currency}
                              {this.state.totalPaidAmt}
                              {/* {this.state.subTotal} */}
                            </span>
                          </p>
                          <p
                            style={{
                              letterSpacing: "0px",
                              color: "#000000",
                              fontSize: "15px",
                              fontWeight: 500,
                              margin: "10px 0px",
                              opacity: 1,
                              fontFamily: "sans-serif",
                            }}
                          >
                            Discounted Price :{" "}
                            <span>
                              {Constant.currency}{" "}
                              {this.state.totaldiscount
                                ? this.state.totaldiscount
                                : "0.00"}
                            </span>
                          </p>
                          <p>
                            Coupon Dis.
                            <span>
                              {" "}
                              - {Constant.currency}{" "}
                              {this.state.totalCoupanAmt
                                ? this.state.totalCoupanAmt
                                : "0.00"}
                            </span>
                          </p>
                          <p
                            style={{
                              letterSpacing: "0px",
                              color: "#000000",
                              fontSize: "15px",
                              fontWeight: 500,
                              margin: "10px 0px",
                              opacity: 1,
                              fontFamily: "sans-serif",
                            }}
                          >
                            Delivery Charges :{" "}
                            <span>
                              {Constant.currency}{" "}
                              {this.state.deliveryCharges
                                ? this.state.deliveryCharges + ".00"
                                : "0.00"}
                            </span>
                          </p>
                          <h2
                            style={{
                              letterSpacing: "0px",
                              color: "#000000",
                              fontSize: "16px",
                              fontWeight: 600,
                              margin: "10px 0px",
                              opacity: 1,
                              fontFamily: "sans-serif",
                            }}
                          >
                            Total Paid:{" "}
                            <span>
                              {Constant.currency}{" "}
                              {parseFloat(this.state.totalpaid)
                                .toFixed(2)
                                .replace(/\d(?=(\d{3})+\.)/g, "$&,")}
                            </span>
                          </h2>
                        </div>
                      </div>
                      <div
                        style={{
                          margin: "10px 0px",
                          float: "left",
                          width: "100%",
                          borderTop: "2px solid #000",
                          borderBottom: "2px solid #000",
                        }}
                      >
                        <div
                          style={{
                            display: "inline-block",
                            verticalAlign: "top",
                          }}
                        >
                          <h4
                            style={{
                              letterSpacing: "0px",
                              color: "#000000",
                              fontSize: "16px",
                              fontWeight: 600,
                              margin: "10px 25px 10px 0px",
                              opacity: 1,
                              fontFamily: "sans-serif",
                            }}
                          >
                            Payment Mode :
                            <span
                              style={{
                                letterSpacing: "0px",
                                color: "#000000",
                                fontSize: "15px",
                                fontWeight: 500,
                                margin: "10px 0px",
                                opacity: 1,
                                fontFamily: "sans-serif",
                              }}
                            >
                              {this.state.payment_mode
                                ? this.state.payment_mode
                                : "Online"}{" "}
                            </span>
                          </h4>
                        </div>
                        <div style={{ display: "inline-block", width: "50%" }}>
                          <h4
                            style={{
                              letterSpacing: "0px",
                              color: "#000000",
                              fontSize: "16px",
                              fontWeight: 600,
                              margin: "10px 0px",
                              opacity: 1,
                              fontFamily: "sans-serif",
                            }}
                          >
                            Delivery Address:
                            <span
                              style={{
                                display: "block",
                                letterSpacing: "0px",
                                color: "#000000",
                                fontSize: "15px",
                                fontWeight: 500,
                                margin: "10px 0px",
                                opacity: 1,
                                fontFamily: "sans-serif",
                                lineHeight: "22px",
                              }}
                            >
                              {this.state.customerName + ", "}
                              {this.state.customerAddress2 + ", "}
                              {this.state.customerLandmark + ", "}
                              {this.state.zipcode + ", "} Mobile:
                              {this.state.customermobile}
                            </span>
                          </h4>
                        </div>
                      </div>
                      <div
                        style={{
                          marginBottom: "60px",
                          width: "100%",
                          float: "left",
                        }}
                      >
                        <div>
                          <p
                            style={{
                              letterSpacing: "0px",
                              color: "#000000",
                              fontSize: "15px",
                              fontWeight: 500,
                              margin: "6px 0px",
                              opacity: 1,
                              fontFamily: "sans-serif",
                            }}
                          >
                            Terms and Conditions
                          </p>
                          <p
                            style={{
                              letterSpacing: "0px",
                              color: "#000000",
                              fontSize: "15px",
                              fontWeight: 500,
                              margin: "6px 0px",
                              opacity: 1,
                              fontFamily: "sans-serif",
                            }}
                          >
                            1. Exchange of goods NOT accepted after 72 hrs of
                            PURCHASE. Bill is required for Exchange.{" "}
                          </p>
                          <p
                            style={{
                              letterSpacing: "0px",
                              color: "#000000",
                              fontSize: "15px",
                              fontWeight: 500,
                              margin: "6px 0px",
                              opacity: 1,
                              fontFamily: "sans-serif",
                            }}
                          >
                            2. Fridge items will not be taken back.
                          </p>
                          <p
                            style={{
                              letterSpacing: "0px",
                              color: "#000000",
                              fontSize: "15px",
                              fontWeight: 500,
                              margin: "6px 0px",
                              opacity: 1,
                              fontFamily: "sans-serif",
                            }}
                          >
                            3. No charge is payable on reverse charge basis.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
            </div>
          </div>
          <ToastContainer />
        </section>
        {this.renderReuploadModal()}
        <Footer />
      </main>
    );
  }
}
